var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _defs, _g21, _g22, _line, _line2, _line3, _line4, _line5, _line6, _g23, _g24, _g25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconSearchInspirationTw68Ajdgfk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#D1D3D4;}\r\n\t.st2{display:inline;fill:#FFFFFF;}\r\n\t.st3{display:inline;fill:#F1F2F2;}\r\n\t.st4{display:inline;fill:none;stroke:#414042;stroke-miterlimit:10;}\r\n\t.st5{display:inline;fill:#414042;}\r\n\t.st6{display:inline;fill:none;stroke:#F5AB35;stroke-miterlimit:10;}\r\n\t.st7{display:inline;}\r\n\t.st8{fill:#36D7B7;}\r\n\t.st9{fill:#86E7D4;}\r\n\t.st10{fill:#5EDFC5;}\r\n\t.st11{fill:#AFEFE2;}\r\n\t.st12{display:inline;fill:#BCBEC0;}\r\n\t.st13{display:inline;fill:#F5AB35;}\r\n\t.st14{display:inline;fill:#36D7B7;}\r\n\t.st15{display:inline;fill:#5EDFC5;}\r\n\t.st16{fill:#29A189;}\r\n\t.st17{fill:none;stroke:#414042;stroke-miterlimit:10;}\r\n\t.st18{display:inline;fill:none;stroke:#414042;stroke-miterlimit:10;stroke-dasharray:1;}\r\n\t.st19{display:inline;fill:#E6E7E8;}\r\n\t.st20{fill:#F1F2F2;}\r\n\t.st21{fill:#FFFFFF;}\r\n\t.st22{fill:#F5AB35;}\r\n\t.st23{fill:#F9CD86;}\r\n\t.st24{display:inline;fill:#29A189;}\r\n\t.st25{display:inline;fill:#F9CD86;}\r\n\t.st26{display:inline;fill:#F7BC5D;}\r\n\t.st27{fill:#BCBEC0;}\r\n\t.st28{fill:#E6E7E8;}\r\n\t.st29{fill:#939598;}\r\n\t.st30{display:inline;fill:#A7A9AC;}\r\n\t.st31{fill:#58595B;}\r\n\t.st32{fill:#414042;}\r\n\t.st33{display:inline;fill:none;stroke:#A7A9AC;stroke-miterlimit:10;}\r\n\t.st34{display:inline;fill:#808285;}\r\n\t.st35{fill:#D1D3D4;}\r\n\t.st36{fill:#A7A9AC;}\r\n\t.st37{display:inline;fill:none;stroke:#414042;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st38{clip-path:url(#XMLID_34_);}\r\n\t.st39{fill:#F7BC5D;}\r\n\t.st40{display:inline;fill:#B88028;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_46_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_243_",
    className: "st1",
    d: "M51,48.4H12.8c-0.6,0-1-0.5-1-1V24.5c0-0.5,0.4-1,1-1H51c0.5,0,1,0.5,1,1v22.9 C52,48,51.6,48.4,51,48.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_242_",
    x: 13.7,
    y: 25.8,
    className: "st2",
    width: 36.1,
    height: 19.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_241_",
    className: "st3",
    d: "M51.5,49.7H12.2c-0.9,0-1.7-0.7-1.9-1.6l-0.3-1.7h43.9l-0.2,1.5 C53.5,48.9,52.6,49.7,51.5,49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_240_",
    className: "st4",
    d: "M51.5,49.7H12.2c-0.9,0-1.7-0.7-1.9-1.6l-0.3-1.7h43.9l-0.2,1.5 C53.5,48.9,52.6,49.7,51.5,49.7z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_249_",
    className: "st4",
    x1: 39.9,
    y1: 23.5,
    x2: 52,
    y2: 23.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_13_",
    className: "st4",
    x1: 11.8,
    y1: 23.5,
    x2: 23.9,
    y2: 23.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_47_",
    className: "st4",
    points: "44.1,20.7 46.4,18.4 44.2,16.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_57_",
    className: "st4",
    points: "20.4,20.7 18.1,18.4 20.2,16.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_86_",
    x: 15.9,
    y: 27,
    className: "st5",
    width: 1.2,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_85_",
    x: 15.9,
    y: 29.6,
    className: "st5",
    width: 1.2,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_84_",
    x: 15.9,
    y: 32.2,
    className: "st5",
    width: 1.2,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_83_",
    x: 15.9,
    y: 34.7,
    className: "st5",
    width: 1.2,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_82_",
    x: 15.9,
    y: 37.3,
    className: "st5",
    width: 1.2,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_81_",
    x: 15.9,
    y: 39.9,
    className: "st5",
    width: 1.2,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_80_",
    x: 15.9,
    y: 42.5,
    className: "st5",
    width: 1.2,
    height: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_79_",
    className: "st4",
    x1: 18.9,
    y1: 27.6,
    x2: 29.2,
    y2: 27.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_78_",
    className: "st6",
    x1: 21.1,
    y1: 30.2,
    x2: 29.2,
    y2: 30.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_77_",
    className: "st4",
    x1: 20,
    y1: 32.7,
    x2: 23.7,
    y2: 32.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_76_",
    className: "st4",
    x1: 24.7,
    y1: 32.7,
    x2: 31.2,
    y2: 32.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_75_",
    className: "st4",
    x1: 33,
    y1: 32.7,
    x2: 45.2,
    y2: 32.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_74_",
    className: "st4",
    x1: 22.2,
    y1: 35.3,
    x2: 30.4,
    y2: 35.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_73_",
    className: "st6",
    x1: 36.5,
    y1: 35.3,
    x2: 31.8,
    y2: 35.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_67_",
    className: "st4",
    x1: 18.9,
    y1: 37.9,
    x2: 38.1,
    y2: 37.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_66_",
    className: "st6",
    x1: 22.3,
    y1: 40.5,
    x2: 32.7,
    y2: 40.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_65_",
    className: "st4",
    x1: 40.2,
    y1: 40.5,
    x2: 35.6,
    y2: 40.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_61_",
    className: "st4",
    x1: 18.9,
    y1: 43.1,
    x2: 29.2,
    y2: 43.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_59_",
    className: "st4",
    x1: 32.9,
    y1: 43.1,
    x2: 43.3,
    y2: 43.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_58_",
    className: "st4",
    x1: 45.2,
    y1: 27.6,
    x2: 35.4,
    y2: 27.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_48_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_63_",
    className: "st8",
    points: "23.9,14.3 21.1,19.1 26.6,19.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_62_",
    className: "st8",
    points: "40.5,14.3 37.8,19.1 43.3,19.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_60_",
    className: "st9",
    points: "29.4,14.3 26.6,19.1 32.2,19.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_56_",
    className: "st10",
    points: "23.9,14.3 26.6,19.1 29.4,14.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_55_",
    className: "st9",
    points: "35,14.3 32.2,19.1 37.8,19.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_54_",
    className: "st10",
    points: "26.6,19.1 32.2,31.7 32.2,19.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_53_",
    className: "st11",
    points: "21.1,19.1 32.2,31.7 26.6,19.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_52_",
    className: "st9",
    points: "43.3,19.1 32.2,31.7 37.8,19.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_51_",
    className: "st8",
    points: "32.2,19.1 32.2,31.7 37.8,19.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_50_",
    className: "st10",
    points: "29.4,14.3 32.2,19.1 35,14.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_49_",
    className: "st10",
    points: "35,14.3 37.8,19.1 40.5,14.3  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_70_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_64_",
    className: "st12",
    points: "22.6,25.7 31.8,27.4 31.8,40.7 22.6,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_69_",
    className: "st13",
    points: "41.3,36.5 31.8,40.6 31.8,27.4 41.3,25.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_68_",
    className: "st14",
    points: "32.2,23.3 41.3,25.7 31.8,28.8 22.7,25.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_71_",
    className: "st4",
    points: "25,26.5 31.8,28.8 31.8,36.8  "
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_87_",
    className: "st4",
    x1: 31.8,
    y1: 28.8,
    x2: 38.2,
    y2: 26.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_72_",
    className: "st4",
    cx: 32,
    cy: 15.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_88_",
    className: "st4",
    cx: 40.1,
    cy: 17.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_89_",
    className: "st4",
    cx: 46,
    cy: 23.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_90_",
    className: "st4",
    cx: 48.2,
    cy: 32,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_91_",
    className: "st4",
    cx: 46.1,
    cy: 40.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_92_",
    className: "st4",
    cx: 40.2,
    cy: 46,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_93_",
    className: "st4",
    cx: 32.1,
    cy: 48.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_94_",
    className: "st4",
    cx: 24,
    cy: 46.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_95_",
    className: "st4",
    cx: 18,
    cy: 40.2,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_96_",
    className: "st4",
    cx: 15.8,
    cy: 32.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_97_",
    className: "st4",
    cx: 17.9,
    cy: 24,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_98_",
    className: "st4",
    cx: 23.7,
    cy: 18,
    r: 1.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_125_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_135_",
    x: 26.1,
    y: 45.1,
    className: "st3",
    width: 11.4,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_134_",
    x: 26.1,
    y: 45.1,
    className: "st1",
    width: 11.4,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_133_",
    x: 26.1,
    y: 45.1,
    className: "st4",
    width: 11.4,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_132_",
    x: 12.9,
    y: 19.2,
    className: "st1",
    width: 37.7,
    height: 22.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_131_",
    x: 14.9,
    y: 21.4,
    className: "st2",
    width: 33.7,
    height: 17.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_103_",
    x: 14.9,
    y: 21.4,
    className: "st15",
    width: 15.6,
    height: 8.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_124_",
    x: 14.9,
    y: 21.4,
    className: "st2",
    width: 15.6,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_113_",
    x: 14.9,
    y: 34.8,
    className: "st13",
    width: 15.6,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_130_",
    x: 12.9,
    y: 40.8,
    className: "st2",
    width: 37.7,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_129_",
    x: 13.3,
    y: 40.8,
    className: "st4",
    width: 37,
    height: 5.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_127_",
    className: "st4",
    x1: 23.9,
    y1: 51.9,
    x2: 39.8,
    y2: 51.9
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_102_",
    className: "st4",
    points: "31.4,22.1 31.4,20 37.6,19.9 42.5,29.9 45.6,29.9  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_100_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_99_",
    x: 29.3,
    y: 21.8,
    className: "st8",
    width: 4.1,
    height: 16.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_101_",
    x: 29.3,
    y: 21.8,
    className: "st16",
    width: 1.3,
    height: 16.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_105_",
    x: 29.3,
    y: 21.8,
    className: "st17",
    width: 4.1,
    height: 16.8
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_104_",
    className: "st13",
    d: "M52.5,31.4L44,31.2c-0.3,0-0.4-2.3-0.1-2.3l8.6-0.4c0.6,0,1.1,0.3,1.1,0.8l0,1.4 C53.6,31.1,53.1,31.4,52.5,31.4z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_106_",
    className: "st4",
    x1: 43.8,
    y1: 27.8,
    x2: 43.8,
    y2: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_849_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_851_",
    className: "st17",
    x1: 22.8,
    y1: 24.9,
    x2: 24.6,
    y2: 26.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_850_",
    className: "st17",
    x1: 22.8,
    y1: 26.7,
    x2: 24.6,
    y2: 24.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_117_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_120_",
    className: "st17",
    x1: 10.4,
    y1: 31.6,
    x2: 12.2,
    y2: 33.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_118_",
    className: "st17",
    x1: 10.4,
    y1: 33.4,
    x2: 12.2,
    y2: 31.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_114_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_116_",
    className: "st17",
    x1: 28.3,
    y1: 14.9,
    x2: 30.1,
    y2: 16.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_115_",
    className: "st17",
    x1: 28.3,
    y1: 16.7,
    x2: 30.1,
    y2: 14.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_107_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_109_",
    className: "st17",
    x1: 14.6,
    y1: 22.9,
    x2: 17.5,
    y2: 25.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_108_",
    className: "st17",
    x1: 14.6,
    y1: 25.8,
    x2: 17.5,
    y2: 22.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_121_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_123_",
    className: "st17",
    x1: 17.9,
    y1: 33.7,
    x2: 20.8,
    y2: 36.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_122_",
    className: "st17",
    x1: 17.9,
    y1: 36.6,
    x2: 20.8,
    y2: 33.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_110_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_112_",
    className: "st17",
    x1: 16.1,
    y1: 12.1,
    x2: 19.8,
    y2: 15.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_111_",
    className: "st17",
    x1: 16.1,
    y1: 15.8,
    x2: 19.8,
    y2: 12.1
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_639_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_154_",
    className: "st18",
    cx: 38.3,
    cy: 32.1,
    r: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_126_",
    className: "st19",
    d: "M37.9,49H18.5c-0.6,0-1-0.5-1-1V16c0-0.5,0.4-1,1-1h19.3c0.5,0,1,0.5,1,1V48 C38.9,48.6,38.4,49,37.9,49z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_140_",
    className: "st4",
    x1: 25.5,
    y1: 17.2,
    x2: 30.9,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_128_",
    x: 19.2,
    y: 19.1,
    className: "st14",
    width: 18,
    height: 25.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_141_",
    x: 21.2,
    y: 24.7,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_142_",
    x: 25.1,
    y: 24.7,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_143_",
    x: 29,
    y: 24.7,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_144_",
    x: 32.9,
    y: 24.7,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_148_",
    x: 21.2,
    y: 28.4,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_147_",
    x: 25.1,
    y: 28.4,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_146_",
    x: 29,
    y: 28.4,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_145_",
    x: 32.9,
    y: 28.4,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_153_",
    x: 21.2,
    y: 32,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_152_",
    x: 25.1,
    y: 32,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_151_",
    x: 29,
    y: 32,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_150_",
    x: 32.9,
    y: 32,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_158_",
    x: 21.2,
    y: 35.7,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_157_",
    x: 25.1,
    y: 35.7,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_156_",
    x: 29,
    y: 35.7,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_155_",
    x: 32.9,
    y: 35.7,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_163_",
    x: 21.2,
    y: 39.4,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_162_",
    x: 25.1,
    y: 39.4,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_161_",
    x: 29,
    y: 39.4,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_160_",
    x: 32.9,
    y: 39.4,
    className: "st5",
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_149_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_138_",
    className: "st20",
    cx: 38.3,
    cy: 32.1,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_137_",
    className: "st17",
    cx: 38.3,
    cy: 32.1,
    r: 5.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_139_",
    className: "st17",
    points: "35.5,31.8 37.5,33.7 41.1,30.1  "
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_208_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_180_",
    className: "st18",
    x1: 20.6,
    y1: 37,
    x2: 43.4,
    y2: 14.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_183_",
    className: "st18",
    x1: 32,
    y1: 41.7,
    x2: 32,
    y2: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_181_",
    className: "st18",
    x1: 43.4,
    y1: 37,
    x2: 20.6,
    y2: 14.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_182_",
    className: "st18",
    x1: 48.2,
    y1: 25.6,
    x2: 15.8,
    y2: 25.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_967_",
    className: "st4",
    x1: 32,
    y1: 35.7,
    x2: 32,
    y2: 54.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_972_",
    className: "st14",
    d: "M40.9,42c0,0,0.5,4.4-2,6.8c-1.4,1.4-3.4,1.8-4.9,2c-1.1,0.1-2-0.8-1.9-1.9 c0.1-1.5,0.6-3.5,2-4.9C36.5,41.5,40.9,42,40.9,42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_966_",
    className: "st4",
    d: "M40.9,42c0,0,0.5,4.4-2,6.8c-1.4,1.4-3.4,1.8-4.9,2c-1.1,0.1-2-0.8-1.9-1.9 c0.1-1.5,0.6-3.5,2-4.9C36.5,41.5,40.9,42,40.9,42z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_970_",
    className: "st4",
    x1: 32.6,
    y1: 50.3,
    x2: 41,
    y2: 41.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_971_",
    className: "st4",
    x1: 37.1,
    y1: 45.7,
    x2: 37.1,
    y2: 42.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_968_",
    className: "st4",
    x1: 34.1,
    y1: 48.8,
    x2: 34.1,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_973_",
    className: "st4",
    x1: 40,
    y1: 47.2,
    x2: 35.7,
    y2: 47.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_981_",
    className: "st14",
    d: "M22.9,42c0,0-0.5,4.4,2,6.8c1.4,1.4,3.4,1.8,4.9,2c1.1,0.1,2-0.8,1.9-1.9 c-0.1-1.5-0.6-3.5-2-4.9C27.3,41.5,22.9,42,22.9,42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_979_",
    className: "st4",
    d: "M22.9,42c0,0-0.5,4.4,2,6.8c1.4,1.4,3.4,1.8,4.9,2c1.1,0.1,2-0.8,1.9-1.9 c-0.1-1.5-0.6-3.5-2-4.9C27.3,41.5,22.9,42,22.9,42z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_978_",
    className: "st4",
    x1: 31.2,
    y1: 50.3,
    x2: 22.7,
    y2: 41.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_977_",
    className: "st4",
    x1: 26.7,
    y1: 45.7,
    x2: 26.7,
    y2: 42.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_976_",
    className: "st4",
    x1: 29.7,
    y1: 48.8,
    x2: 29.7,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_975_",
    className: "st4",
    x1: 23.7,
    y1: 47.2,
    x2: 28.1,
    y2: 47.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_230_",
    className: "st3",
    d: "M34.4,36.3v4.6c0,1.4-1.1,2.5-2.5,2.5l0,0c-1.4,0-2.5-1.1-2.5-2.5v-4.6H34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_229_",
    className: "st4",
    d: "M34.4,36.3v4.6c0,1.4-1.1,2.5-2.5,2.5l0,0c-1.4,0-2.5-1.1-2.5-2.5v-4.6H34.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_227_",
    className: "st13",
    cx: 32,
    cy: 25.5,
    r: 9.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_226_",
    x: 27.5,
    y: 27.5,
    className: "st13",
    width: 8.9,
    height: 10.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_225_",
    x: 27.5,
    y: 37.2,
    className: "st19",
    width: 9.1,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_224_",
    x: 27.5,
    y: 37.2,
    className: "st4",
    width: 9.1,
    height: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_178_",
    className: "st4",
    x1: 31.9,
    y1: 37.2,
    x2: 31.9,
    y2: 25.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_179_",
    className: "st4",
    x1: 35.1,
    y1: 25.7,
    x2: 28.8,
    y2: 25.7
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_207_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_170_",
    x: 17,
    y: 23.3,
    className: "st3",
    width: 29.7,
    height: 28.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_187_",
    x: 17.3,
    y: 20.4,
    className: "st14",
    width: 29,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_192_",
    x: 17.3,
    y: 20.4,
    className: "st4",
    width: 29,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_184_",
    className: "st2",
    d: "M37.9,37.4l-1.1,0c-0.1-0.6-0.4-1.1-0.6-1.6l0.8-0.8c0.3-0.3,0.3-0.7,0-1l-0.6-0.6 c-0.3-0.3-0.7-0.3-1,0l-0.8,0.8c-0.5-0.3-1-0.5-1.6-0.6v-1.1c0-0.4-0.3-0.7-0.7-0.7h-0.8c-0.4,0-0.7,0.3-0.7,0.7v1.1 c-0.6,0.1-1.1,0.3-1.5,0.6l-0.8-0.8c-0.3-0.3-0.7-0.3-1,0L26.9,34c-0.3,0.3-0.3,0.7,0,1l0.8,0.8c-0.3,0.5-0.5,1-0.7,1.6l-1.1,0 c-0.4,0-0.7,0.3-0.7,0.7l0,0.8c0,0.4,0.3,0.7,0.7,0.7l1.1,0c0.1,0.6,0.3,1.1,0.6,1.6l-0.8,0.8c-0.3,0.3-0.3,0.7,0,1l0.6,0.6 c0.3,0.3,0.7,0.3,1,0l0.8-0.8c0.5,0.3,1,0.5,1.6,0.7l0,1.1c0,0.4,0.3,0.7,0.7,0.7l0.8,0c0.4,0,0.7-0.3,0.7-0.7l0-1.1 c0.6-0.1,1.1-0.3,1.6-0.6l0.8,0.8c0.3,0.3,0.7,0.3,1,0l0.6-0.6c0.3-0.3,0.3-0.7,0-1l-0.8-0.8c0.3-0.5,0.5-1,0.7-1.6l1.1,0 c0.4,0,0.7-0.3,0.7-0.7V38C38.6,37.7,38.2,37.4,37.9,37.4z M31.9,40.7c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2 c1.2,0,2.2,1,2.2,2.2C34.1,39.7,33.1,40.7,31.9,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_216_",
    className: "st4",
    d: "M37.9,37.4l-1.1,0c-0.1-0.6-0.4-1.1-0.6-1.6l0.8-0.8c0.3-0.3,0.3-0.7,0-1l-0.6-0.6 c-0.3-0.3-0.7-0.3-1,0l-0.8,0.8c-0.5-0.3-1-0.5-1.6-0.6v-1.1c0-0.4-0.3-0.7-0.7-0.7h-0.8c-0.4,0-0.7,0.3-0.7,0.7v1.1 c-0.6,0.1-1.1,0.3-1.5,0.6l-0.8-0.8c-0.3-0.3-0.7-0.3-1,0L26.9,34c-0.3,0.3-0.3,0.7,0,1l0.8,0.8c-0.3,0.5-0.5,1-0.7,1.6l-1.1,0 c-0.4,0-0.7,0.3-0.7,0.7l0,0.8c0,0.4,0.3,0.7,0.7,0.7l1.1,0c0.1,0.6,0.3,1.1,0.6,1.6l-0.8,0.8c-0.3,0.3-0.3,0.7,0,1l0.6,0.6 c0.3,0.3,0.7,0.3,1,0l0.8-0.8c0.5,0.3,1,0.5,1.6,0.7l0,1.1c0,0.4,0.3,0.7,0.7,0.7l0.8,0c0.4,0,0.7-0.3,0.7-0.7l0-1.1 c0.6-0.1,1.1-0.3,1.6-0.6l0.8,0.8c0.3,0.3,0.7,0.3,1,0l0.6-0.6c0.3-0.3,0.3-0.7,0-1l-0.8-0.8c0.3-0.5,0.5-1,0.7-1.6l1.1,0 c0.4,0,0.7-0.3,0.7-0.7V38C38.6,37.7,38.2,37.4,37.9,37.4z M31.9,40.7c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2 c1.2,0,2.2,1,2.2,2.2C34.1,39.7,33.1,40.7,31.9,40.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_188_",
    className: "st2",
    cx: 38.6,
    cy: 22.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_189_",
    className: "st2",
    cx: 40.7,
    cy: 22.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_190_",
    className: "st2",
    cx: 42.8,
    cy: 22.8,
    r: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_347_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_346_",
    className: "st21",
    d: "M47.3,51.5H15.5v-3.4h31.9l4.2,1.6c0.1,0,0.1,0.1,0,0.2L47.3,51.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_345_",
    x: 15.5,
    y: 48.1,
    className: "st8",
    width: 31.9,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_344_",
    x: 15.5,
    y: 48.1,
    className: "st9",
    width: 31.9,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_343_",
    x: 15.5,
    y: 48,
    className: "st21",
    width: 4,
    height: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_342_",
    className: "st17",
    d: "M47.3,51.5H15.5v-3.4h31.9l4.2,1.6c0.1,0,0.1,0.1,0,0.2L47.3,51.5z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_341_",
    className: "st17",
    x1: 19.4,
    y1: 48.1,
    x2: 19.4,
    y2: 51.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_340_",
    className: "st17",
    x1: 47.3,
    y1: 48.3,
    x2: 47.3,
    y2: 51.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_338_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_327_",
    x: 12.4,
    y: 12,
    className: "st22",
    width: 8.3,
    height: 40.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_329_",
    x: 17,
    y: 12,
    className: "st23",
    width: 3.7,
    height: 40.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_331_",
    className: "st17",
    x1: 20.7,
    y1: 18,
    x2: 18.1,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_326_",
    className: "st17",
    x1: 20.7,
    y1: 12.5,
    x2: 18.1,
    y2: 12.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_330_",
    className: "st17",
    x1: 20.7,
    y1: 23.6,
    x2: 18.1,
    y2: 23.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_332_",
    className: "st17",
    x1: 20.7,
    y1: 29.2,
    x2: 18.1,
    y2: 29.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_333_",
    className: "st17",
    x1: 20.7,
    y1: 34.8,
    x2: 18.1,
    y2: 34.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_334_",
    className: "st17",
    x1: 20.7,
    y1: 46,
    x2: 18.1,
    y2: 46
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_335_",
    className: "st17",
    x1: 20.7,
    y1: 40.4,
    x2: 18.1,
    y2: 40.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_337_",
    className: "st17",
    x1: 20.7,
    y1: 51.5,
    x2: 18.1,
    y2: 51.5
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_209_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_191_",
    x: 14.4,
    y: 32.9,
    className: "st19",
    width: 33.8,
    height: 19.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_193_",
    x: 17.4,
    y: 35.6,
    className: "st13",
    width: 27.8,
    height: 14
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_798_",
    className: "st19",
    points: "30.9,49.4 24.7,41.4 18.1,49.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_194_",
    className: "st4",
    points: "27.8,45.4 24.7,41.4 18.1,49.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_796_",
    className: "st2",
    points: "39.7,49.2 31.7,39 23.3,49.2  "
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_800_",
    className: "st4",
    x1: 17.4,
    y1: 49.4,
    x2: 45.3,
    y2: 49.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_368_",
    className: "st3",
    d: "M41.8,41.7c0-0.2-0.1-0.3-0.3-0.3c0,0-0.1,0-0.1,0c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0-0.1,0-0.1 c0-0.3-0.2-0.5-0.5-0.5c-0.1,0-0.3,0.1-0.4,0.1c0-0.5-0.5-0.9-1-0.9c-0.5,0-0.8,0.3-1,0.7c0,0-0.1,0-0.1,0c-0.3,0-0.6,0.2-0.7,0.5 c-0.1,0-0.1,0-0.2,0c-0.3,0-0.6,0.3-0.6,0.6c0,0.1,0,0.2,0.1,0.3h5.1C41.8,41.8,41.8,41.8,41.8,41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_195_",
    className: "st3",
    d: "M21.9,42.4c0-0.1-0.1-0.2-0.2-0.2c0,0-0.1,0-0.1,0c0-0.1-0.1-0.1-0.2-0.1c0,0,0,0,0-0.1 c0-0.2-0.1-0.3-0.3-0.3c-0.1,0-0.2,0-0.2,0.1c0-0.3-0.3-0.5-0.6-0.5c-0.3,0-0.5,0.2-0.5,0.4c0,0-0.1,0-0.1,0 c-0.2,0-0.3,0.1-0.4,0.3c0,0-0.1,0-0.1,0c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.1,0.1,0.2L21.9,42.4C21.9,42.4,21.9,42.4,21.9,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_197_",
    className: "st3",
    d: "M29.1,39.5c0-0.2-0.1-0.3-0.3-0.3c0,0-0.1,0-0.1,0c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0-0.1,0-0.1 c0-0.3-0.2-0.5-0.5-0.5c-0.1,0-0.2,0-0.3,0.1c0-0.4-0.4-0.8-0.9-0.8c-0.4,0-0.7,0.3-0.8,0.6c0,0-0.1,0-0.1,0 c-0.3,0-0.5,0.2-0.6,0.4c-0.1,0-0.1,0-0.2,0c-0.3,0-0.5,0.2-0.5,0.5c0,0.1,0,0.2,0.1,0.3H29C29,39.6,29.1,39.6,29.1,39.5z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_196_",
    className: "st4",
    points: "23.3,49.2 31.7,39 39.7,49.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_371_",
    className: "st14",
    d: "M45.4,22.5c0-1-0.8-1.8-1.8-1.8c-0.3,0-0.5,0.1-0.8,0.2c-0.3-0.7-1-1.2-1.8-1.3 c0-0.2,0.1-0.3,0.1-0.5c0-1.7-1.3-3-3-3c-0.8,0-1.5,0.3-2,0.8c-0.2-2.9-2.6-5.1-5.5-5.1c-2.5,0-4.6,1.7-5.3,4 c-0.2,0-0.5-0.1-0.8-0.1c-1.8,0-3.2,1.2-3.6,2.8c-0.4-0.2-0.8-0.3-1.3-0.3c-1.9,0-3.4,1.5-3.4,3.4c0,0.6,0.2,1.2,0.5,1.7h28.3 C45.3,23.2,45.4,22.9,45.4,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_495_",
    className: "st24",
    d: "M24.1,16.5c1.8,0,3.3,1.5,3.3,3.3c0,0.4-0.1,0.7-0.2,1.1c0.3-0.5,0.5-1.1,0.5-1.8 c0-1.8-1.5-3.3-3.3-3.3h0c-1.4,0-2.6,0.9-3.1,2.2C22,17,23,16.5,24.1,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_492_",
    className: "st24",
    d: "M40.4,20c-0.8,0.6-1.9,0.4-2.5-0.4c-0.1-0.2-0.2-0.3-0.2-0.5c0,0.3,0.1,0.7,0.3,1 c0.6,0.8,1.7,1,2.5,0.4l0,0c0.6-0.5,0.9-1.3,0.7-2C41.1,19.1,40.9,19.7,40.4,20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_389_",
    className: "st4",
    d: "M41.2,19c0-1.7-1.3-3-3-3c-0.8,0-1.5,0.3-2,0.8c-0.2-2.9-2.6-5.1-5.5-5.1 c-2.5,0-4.6,1.7-5.3,4"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_199_",
    className: "st4",
    x1: 16.9,
    y1: 23.4,
    x2: 29.1,
    y2: 23.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_198_",
    className: "st4",
    x1: 39.4,
    y1: 23.4,
    x2: 30.8,
    y2: 23.4
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_1235_",
    className: "st4",
    points: "27.3,27.1 28.8,25.7 30.2,27.1  "
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1239_",
    className: "st4",
    x1: 28.8,
    y1: 25.7,
    x2: 28.8,
    y2: 30.1
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_202_",
    className: "st6",
    points: "32.8,28.6 34.3,30.1 35.7,28.6  "
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_201_",
    className: "st6",
    x1: 34.3,
    y1: 30,
    x2: 34.3,
    y2: 25.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_808_",
    className: "st4",
    x1: 39.2,
    y1: 26.4,
    x2: 49.7,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_205_",
    className: "st4",
    x1: 43.6,
    y1: 29.3,
    x2: 51.1,
    y2: 29.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_206_",
    className: "st4",
    x1: 36.7,
    y1: 29.3,
    x2: 42.2,
    y2: 29.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_204_",
    className: "st4",
    x1: 13.7,
    y1: 26.4,
    x2: 24.2,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_200_",
    className: "st4",
    x1: 18.5,
    y1: 29.3,
    x2: 26.4,
    y2: 29.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_203_",
    className: "st4",
    x1: 17,
    y1: 29.3,
    x2: 12.9,
    y2: 29.3
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_236_",
    transform: "matrix(0.9227 0.3855 -0.3855 0.9227 13.2122 -11.0002)",
    className: "st12",
    cx: 34,
    cy: 27.4,
    rx: 1.6,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_235_",
    transform: "matrix(0.3797 0.9251 -0.9251 0.3797 50.7147 -15.2811)",
    className: "st12",
    cx: 36.8,
    cy: 30.2,
    rx: 1.6,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_234_",
    transform: "matrix(-0.3856 0.9226 -0.9226 -0.3856 82.3123 13.2622)",
    className: "st12",
    cx: 36.7,
    cy: 34,
    rx: 1.6,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_233_",
    transform: "matrix(-0.9251 0.3797 -0.3797 -0.9251 79.4181 57.8443)",
    className: "st12",
    cx: 34,
    cy: 36.8,
    rx: 1.6,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_232_",
    transform: "matrix(-0.9226 -0.3858 0.3858 -0.9226 43.7913 82.2678)",
    className: "st13",
    cx: 30.1,
    cy: 36.7,
    rx: 1.6,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_231_",
    transform: "matrix(-0.3796 -0.9252 0.9252 -0.3796 6.3832 72.2903)",
    className: "st13",
    cx: 27.4,
    cy: 34,
    rx: 1.6,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_228_",
    transform: "matrix(0.3859 -0.9226 0.9226 0.3859 -10.9589 43.8351)",
    className: "st13",
    cx: 27.4,
    cy: 30.1,
    rx: 1.6,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_223_",
    transform: "matrix(0.9252 -0.3794 0.3794 0.9252 -8.1516 13.5034)",
    className: "st13",
    cx: 30.2,
    cy: 27.4,
    rx: 1.6,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_211_",
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 30.297 -17.6347)",
    className: "st1",
    cx: 36.4,
    cy: 27.8,
    rx: 2,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_212_",
    className: "st1",
    cx: 38.2,
    cy: 32.1,
    rx: 6.1,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_213_",
    transform: "matrix(-0.7072 0.707 -0.707 -0.7072 87.958 36.4439)",
    className: "st1",
    cx: 36.4,
    cy: 36.4,
    rx: 2,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_215_",
    transform: "matrix(-0.7069 -0.7073 0.7073 -0.7069 21.5977 81.8148)",
    className: "st25",
    cx: 27.8,
    cy: 36.4,
    rx: 2,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_219_",
    className: "st25",
    cx: 26,
    cy: 32.1,
    rx: 6.1,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_220_",
    transform: "matrix(0.7074 -0.7068 0.7068 0.7074 -11.4933 27.7373)",
    className: "st25",
    cx: 27.8,
    cy: 27.7,
    rx: 2,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_237_",
    className: "st18",
    cx: 32.1,
    cy: 32.1,
    r: 14.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_238_",
    className: "st25",
    d: "M30.1,38.2c0,3.3,0.9,6.1,1.9,6.1V32.1C31,32.2,30.1,34.9,30.1,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_244_",
    className: "st1",
    d: "M32.1,32.1C32.1,32.1,32.1,32.1,32.1,32.1l0,12.3c0,0,0,0,0,0c1.1,0,2-2.7,2-6.1 C34.1,34.8,33.2,32.1,32.1,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_245_",
    className: "st25",
    d: "M30.1,26c0,3.3,0.9,6.1,1.9,6.1V19.8C31,19.9,30.1,22.6,30.1,26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_246_",
    className: "st1",
    d: "M32.1,19.8C32.1,19.8,32.1,19.8,32.1,19.8l0,12.3c0,0,0,0,0,0c1.1,0,2-2.7,2-6.1 S33.2,19.8,32.1,19.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_221_",
    className: "st2",
    cx: 32.1,
    cy: 32.1,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_222_",
    className: "st4",
    cx: 32.1,
    cy: 32.1,
    r: 3.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_214_",
    className: "st4",
    x1: 15.2,
    y1: 32.1,
    x2: 19.7,
    y2: 32.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_239_",
    className: "st4",
    x1: 44.3,
    y1: 32.1,
    x2: 48.8,
    y2: 32.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_210_",
    className: "st4",
    x1: 32.1,
    y1: 15.2,
    x2: 32.1,
    y2: 19.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_247_",
    className: "st4",
    x1: 32.1,
    y1: 44.3,
    x2: 32.1,
    y2: 48.8
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_268_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_248_",
    x: 15.1,
    y: 11.5,
    className: "st3",
    width: 33.9,
    height: 37.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_250_",
    x: 15.6,
    y: 11.7,
    className: "st15",
    width: 32.9,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_251_",
    x: 15.6,
    y: 11.7,
    className: "st4",
    width: 32.9,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_252_",
    x: 19.9,
    y: 17.6,
    className: "st26",
    width: 24.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_253_",
    x: 19.9,
    y: 28.8,
    className: "st1",
    width: 11.6,
    height: 5.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_256_",
    x: 32.5,
    y: 28.8,
    className: "st19",
    width: 11.8,
    height: 5.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_255_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_257_",
    x: 22.3,
    y: 35.5,
    className: "st27",
    width: 20.3,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_259_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_260_",
    x: 22.3,
    y: 41.3,
    className: "st28",
    width: 20.3,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_261_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_262_",
    x: 22.3,
    y: 42.8,
    className: "st28",
    width: 20.3,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_263_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_264_",
    x: 22.3,
    y: 44.4,
    className: "st28",
    width: 20.3,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_254_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_258_",
    x: 27.9,
    y: 37.4,
    className: "st27",
    width: 9,
    height: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1479_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1488_",
    className: "st17",
    x1: 32,
    y1: 33.7,
    x2: 32,
    y2: 37.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1485_",
    className: "st29",
    d: "M32,16c-5,0-9.1,4.1-9.1,9.1c0,5,4.1,9.1,9.1,9.1c5,0,9.1-4.1,9.1-9.1 C41.1,20.1,37,16,32,16z M32,33.2c-4.5,0-8.1-3.6-8.1-8.1S27.5,17,32,17c4.5,0,8.1,3.6,8.1,8.1S36.5,33.2,32,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1484_",
    className: "st17",
    d: "M32,18.9c3.5,0,6.2,2.8,6.2,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1483_",
    className: "st10",
    d: "M30.2,36.4v14.3c0,1,0.8,1.8,1.8,1.8V36.4H30.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1482_",
    className: "st8",
    d: "M32,36.4v16.1c1,0,1.8-0.8,1.8-1.8V36.4H32z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1481_",
    className: "st17",
    x1: 30.1,
    y1: 39,
    x2: 33.9,
    y2: 39
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1480_",
    className: "st17",
    x1: 30.1,
    y1: 40.5,
    x2: 33.9,
    y2: 40.5
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_265_",
    className: "st2",
    cx: 18.1,
    cy: 13.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_266_",
    className: "st2",
    cx: 19.9,
    cy: 13.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_267_",
    className: "st2",
    cx: 21.6,
    cy: 13.3,
    r: 0.6
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_496_",
    className: "st4",
    points: "48.9,32.3 48.9,49.2 35.1,49.2  "
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_504_",
    className: "st4",
    x1: 15.1,
    y1: 49.2,
    x2: 28.3,
    y2: 49.3
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_294_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_284_",
    className: "st1",
    d: "M30,17.5h2.8l8.7,2.1c0.8,0.2,1.4,0.9,1.4,1.7v0.5H30V17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_297_",
    className: "st30",
    d: "M30,20.7v1.1h12.9v-0.5c0-0.2,0-0.4-0.1-0.6H30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_285_",
    className: "st1",
    d: "M30,30.4h2.8l8.7-2.1c0.8-0.2,1.4-0.9,1.4-1.7v-0.5H30V30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_298_",
    className: "st30",
    d: "M42.9,26.6v-0.5H30v1.1h12.8C42.9,27,42.9,26.8,42.9,26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_286_",
    className: "st1",
    d: "M23.3,26.2h-2l-6.2,1.5c-0.6,0.1-1,0.6-1,1.2v0.4h9.2V26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_295_",
    className: "st12",
    d: "M14.1,28.9v0.4h9.2v-0.6h-9.2C14.1,28.8,14.1,28.9,14.1,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_277_",
    className: "st1",
    d: "M23.3,22h-2l-6.2-1.5c-0.6-0.1-1-0.6-1-1.2v-0.4h9.2V22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_296_",
    className: "st12",
    d: "M14.1,18.9v0.4c0,0,0,0,0,0.1h9.2v-0.4H14.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_269_",
    x: 22.9,
    y: 17.5,
    className: "st3",
    width: 7.1,
    height: 35.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_270_",
    x: 26.4,
    y: 17.5,
    className: "st19",
    width: 3.6,
    height: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_272_",
    className: "st4",
    x1: 22.9,
    y1: 21.4,
    x2: 26.1,
    y2: 21.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_271_",
    className: "st4",
    x1: 22.9,
    y1: 24.4,
    x2: 26.1,
    y2: 24.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_273_",
    className: "st4",
    x1: 22.9,
    y1: 27.3,
    x2: 26.1,
    y2: 27.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_278_",
    className: "st4",
    x1: 22.9,
    y1: 42.3,
    x2: 26.1,
    y2: 42.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_279_",
    className: "st4",
    x1: 22.9,
    y1: 45.3,
    x2: 26.1,
    y2: 45.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_280_",
    className: "st4",
    x1: 22.9,
    y1: 48.3,
    x2: 26.1,
    y2: 48.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_281_",
    className: "st4",
    x1: 22.9,
    y1: 51.3,
    x2: 26.1,
    y2: 51.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_274_",
    x: 21.2,
    y: 31.5,
    className: "st15",
    width: 9.2,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_275_",
    x: 25.8,
    y: 31.5,
    className: "st14",
    width: 4.6,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_283_",
    x: 21.2,
    y: 31.5,
    className: "st4",
    width: 9.2,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_287_",
    x: 19.5,
    y: 35.8,
    className: "st5",
    width: 2,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_276_",
    x: 18.3,
    y: 35,
    className: "st1",
    width: 2,
    height: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_288_",
    className: "st13",
    cx: 39.1,
    cy: 23.9,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_291_",
    className: "st18",
    cx: 39.1,
    cy: 23.9,
    r: 3.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_293_",
    className: "st18",
    x1: 32.6,
    y1: 14.1,
    x2: 49.9,
    y2: 14.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_292_",
    className: "st18",
    x1: 47.1,
    y1: 28.6,
    x2: 47.1,
    y2: 11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_289_",
    x: 18.3,
    y: 38.4,
    className: "st30",
    width: 2,
    height: 1.4
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_311_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_307_",
    className: "st19",
    d: "M49.2,32c0,0-9.5,10.6-17.2,10.6S14.8,32,14.8,32S24.3,21.4,32,21.4S49.2,32,49.2,32z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_304_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_306_",
    className: "st22",
    d: "M39.6,32c0-4.2-3.4-7.6-7.6-7.6l0,15.2C36.2,39.6,39.6,36.2,39.6,32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_305_",
    className: "st8",
    d: "M32,24.4c-4.2,0-7.6,3.4-7.6,7.6c0,4.2,3.4,7.6,7.6,7.6c0,0,0,0,0,0L32,24.4 C32,24.4,32,24.4,32,24.4z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_302_",
    className: "st2",
    cx: 32,
    cy: 32,
    r: 3.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_299_",
    className: "st4",
    d: "M40,32c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8C36.4,24,40,27.6,40,32z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_301_",
    className: "st5",
    cx: 32,
    cy: 32,
    r: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_300_",
    className: "st18",
    d: "M48.8,32c0,9.3-7.5,16.8-16.8,16.8c-9.3,0-16.8-7.5-16.8-16.8c0-9.3,7.5-16.8,16.8-16.8 C41.3,15.2,48.8,22.7,48.8,32z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_308_",
    className: "st18",
    x1: 32.1,
    y1: 17.4,
    x2: 32.1,
    y2: 28.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_303_",
    className: "st18",
    x1: 32.1,
    y1: 35.7,
    x2: 32.1,
    y2: 46.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_310_",
    className: "st18",
    x1: 36.2,
    y1: 32,
    x2: 47.1,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_309_",
    className: "st18",
    x1: 16.8,
    y1: 32,
    x2: 27.7,
    y2: 32
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_470_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_356_",
    className: "st4",
    d: "M32.1,38.2v-1.3c0-0.7-0.5-1.2-1.2-1.2h-8.2c-0.7,0-1.2-0.5-1.2-1.2v0c0-0.7,0.5-1.2,1.2-1.2 h19.1c0.7,0,1.2-0.5,1.2-1.2v-0.2c0-0.7-0.5-1.2-1.2-1.2H22.7c-0.7,0-1.2-0.5-1.2-1.2v-0.1c0-0.7,0.5-1.2,1.2-1.2h19.1 c0.7,0,1.2-0.5,1.2-1.2v-0.3c0-0.7-0.5-1.2-1.2-1.2h-8.5c-0.7,0-1.2-0.5-1.2-1.2v-6.1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_370_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_425_",
    className: "st17",
    x1: 45.3,
    y1: 17,
    x2: 47.1,
    y2: 18.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_424_",
    className: "st17",
    x1: 45.3,
    y1: 18.7,
    x2: 47.1,
    y2: 17
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_467_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_469_",
    className: "st17",
    x1: 46.5,
    y1: 31.3,
    x2: 48.2,
    y2: 33
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_468_",
    className: "st17",
    x1: 46.5,
    y1: 33,
    x2: 48.2,
    y2: 31.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_461_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_463_",
    className: "st17",
    x1: 12.6,
    y1: 24,
    x2: 15.2,
    y2: 26.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_462_",
    className: "st17",
    x1: 12.6,
    y1: 26.6,
    x2: 15.2,
    y2: 24
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_458_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_460_",
    className: "st17",
    x1: 21.1,
    y1: 13,
    x2: 22.8,
    y2: 14.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_459_",
    className: "st17",
    x1: 21.1,
    y1: 14.8,
    x2: 22.8,
    y2: 13
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_464_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_466_",
    className: "st17",
    x1: 18,
    y1: 33,
    x2: 19.7,
    y2: 34.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_465_",
    className: "st17",
    x1: 18,
    y1: 34.8,
    x2: 19.7,
    y2: 33
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_355_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_457_",
    className: "st17",
    x1: 48.4,
    y1: 23.6,
    x2: 51,
    y2: 26.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_456_",
    className: "st17",
    x1: 48.4,
    y1: 26.2,
    x2: 51,
    y2: 23.6
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_312_",
    x: 15.8,
    y: 37.5,
    className: "st19",
    width: 32.6,
    height: 15.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_328_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_314_",
    x: 17.1,
    y: 38.9,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_315_",
    x: 20.7,
    y: 38.9,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_316_",
    x: 24.2,
    y: 38.9,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_317_",
    x: 27.7,
    y: 38.9,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_318_",
    x: 31.2,
    y: 38.9,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_319_",
    x: 34.8,
    y: 38.9,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_320_",
    x: 38.3,
    y: 38.9,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_321_",
    x: 41.8,
    y: 38.9,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_322_",
    x: 45.4,
    y: 38.9,
    className: "st31",
    width: 1.7,
    height: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_325_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_354_",
    x: 17.1,
    y: 41.7,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_353_",
    x: 20.7,
    y: 41.7,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_352_",
    x: 24.2,
    y: 41.7,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_351_",
    x: 27.7,
    y: 41.7,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_350_",
    x: 31.2,
    y: 41.7,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_349_",
    x: 34.8,
    y: 41.7,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_348_",
    x: 38.3,
    y: 41.7,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_339_",
    x: 41.8,
    y: 41.7,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_336_",
    x: 45.4,
    y: 41.7,
    className: "st31",
    width: 1.7,
    height: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_324_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_366_",
    x: 17.1,
    y: 44.5,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_365_",
    x: 20.7,
    y: 44.5,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_364_",
    x: 24.2,
    y: 44.5,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_363_",
    x: 27.7,
    y: 44.5,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_362_",
    x: 31.2,
    y: 44.5,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_361_",
    x: 34.8,
    y: 44.5,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_360_",
    x: 38.3,
    y: 44.5,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_359_",
    x: 41.8,
    y: 44.5,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_358_",
    x: 45.4,
    y: 44.5,
    className: "st31",
    width: 1.7,
    height: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_323_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_380_",
    x: 17.1,
    y: 47.3,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_379_",
    x: 20.7,
    y: 47.3,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_378_",
    x: 24.2,
    y: 47.3,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_377_",
    x: 27.7,
    y: 47.3,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_376_",
    x: 31.2,
    y: 47.3,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_375_",
    x: 34.8,
    y: 47.3,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_374_",
    x: 38.3,
    y: 47.3,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_373_",
    x: 41.8,
    y: 47.3,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_372_",
    x: 45.4,
    y: 47.3,
    className: "st31",
    width: 1.7,
    height: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_313_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_393_",
    x: 17.1,
    y: 50.1,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_392_",
    x: 20.7,
    y: 50.1,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_388_",
    x: 24.2,
    y: 50.1,
    className: "st31",
    width: 15.8,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_385_",
    x: 41.8,
    y: 50.1,
    className: "st31",
    width: 1.7,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_384_",
    x: 45.4,
    y: 50.1,
    className: "st31",
    width: 1.7,
    height: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_417_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_418_",
    className: "st32",
    d: "M30.8,15.7c-0.2,0.1-0.6,0.2-1,0.2c-1.1,0-1.9-0.7-1.9-2c0-1.2,0.8-2,2-2 c0.5,0,0.8,0.1,0.9,0.2l-0.1,0.4c-0.2-0.1-0.5-0.2-0.8-0.2c-0.9,0-1.5,0.6-1.5,1.6c0,1,0.5,1.6,1.5,1.6c0.3,0,0.6-0.1,0.8-0.2 L30.8,15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_420_",
    className: "st32",
    d: "M31.3,15.2c0.2,0.1,0.6,0.3,0.9,0.3c0.5,0,0.8-0.3,0.8-0.7c0-0.4-0.2-0.6-0.7-0.8 c-0.6-0.2-1-0.6-1-1.1c0-0.6,0.5-1.1,1.3-1.1c0.4,0,0.7,0.1,0.9,0.2l-0.1,0.4c-0.1-0.1-0.4-0.2-0.7-0.2c-0.5,0-0.7,0.3-0.7,0.6 c0,0.4,0.2,0.5,0.8,0.8c0.7,0.3,1,0.6,1,1.1c0,0.6-0.4,1.1-1.4,1.1c-0.4,0-0.8-0.1-1-0.2L31.3,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_422_",
    className: "st32",
    d: "M34.2,15.2c0.2,0.1,0.6,0.3,0.9,0.3c0.5,0,0.8-0.3,0.8-0.7c0-0.4-0.2-0.6-0.7-0.8 c-0.6-0.2-1-0.6-1-1.1c0-0.6,0.5-1.1,1.3-1.1c0.4,0,0.7,0.1,0.9,0.2l-0.1,0.4c-0.1-0.1-0.4-0.2-0.7-0.2c-0.5,0-0.7,0.3-0.7,0.6 c0,0.4,0.2,0.5,0.8,0.8c0.7,0.3,1,0.6,1,1.1c0,0.6-0.4,1.1-1.4,1.1c-0.4,0-0.8-0.1-1-0.2L34.2,15.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_408_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_409_",
    className: "st8",
    d: "M19.8,20.2v1.2h1.4v-1.2h0.4v2.9h-0.4v-1.4h-1.4v1.4h-0.4v-2.9H19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_411_",
    className: "st8",
    d: "M22.8,20.5h-0.9v-0.3h2.2v0.3h-0.9v2.6h-0.4V20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_413_",
    className: "st8",
    d: "M26.9,21.8c0-0.4,0-0.9,0-1.3h0c-0.1,0.3-0.2,0.7-0.4,1.1l-0.5,1.4h-0.3l-0.5-1.4 c-0.1-0.4-0.3-0.8-0.3-1.1h0c0,0.4,0,0.9-0.1,1.3l-0.1,1.2h-0.4l0.2-2.9H25l0.5,1.4c0.1,0.4,0.2,0.7,0.3,1h0 c0.1-0.3,0.2-0.6,0.3-1l0.5-1.4h0.5l0.2,2.9h-0.4L26.9,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_415_",
    className: "st8",
    d: "M27.9,20.2h0.4v2.6h1.2v0.3h-1.6V20.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_403_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_404_",
    className: "st22",
    d: "M12.6,13.5h0.6v2.9c0,1.2-0.6,1.5-1.3,1.5c-0.2,0-0.5,0-0.6-0.1l0.1-0.5 c0.1,0,0.3,0.1,0.5,0.1c0.5,0,0.8-0.2,0.8-1.1V13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_406_",
    className: "st22",
    d: "M14,17.2c0.3,0.2,0.6,0.3,1,0.3c0.6,0,0.9-0.3,0.9-0.8c0-0.4-0.2-0.6-0.8-0.9 c-0.7-0.3-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.4-1.2c0.5,0,0.8,0.1,1,0.2l-0.2,0.5c-0.1-0.1-0.4-0.2-0.8-0.2c-0.6,0-0.8,0.4-0.8,0.7 c0,0.4,0.3,0.6,0.9,0.9c0.7,0.3,1.1,0.6,1.1,1.3c0,0.7-0.5,1.3-1.5,1.3c-0.4,0-0.9-0.1-1.1-0.3L14,17.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_396_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_397_",
    className: "st8",
    d: "M46.7,14.1c-0.2,0.1-0.5,0.2-0.9,0.2c-1,0-1.7-0.6-1.7-1.8c0-1.1,0.7-1.8,1.8-1.8 c0.4,0,0.7,0.1,0.8,0.2l-0.1,0.4c-0.2-0.1-0.4-0.1-0.7-0.1c-0.8,0-1.4,0.5-1.4,1.4c0,0.8,0.5,1.4,1.3,1.4c0.3,0,0.6-0.1,0.7-0.1 L46.7,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_399_",
    className: "st8",
    d: "M48.5,11.4v1.2h1.2v0.3h-1.2v1.2h-0.3v-1.2h-1.2v-0.3h1.2v-1.2H48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_401_",
    className: "st8",
    d: "M51.6,11.4v1.2h1.2v0.3h-1.2v1.2h-0.3v-1.2h-1.2v-0.3h1.2v-1.2H51.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_381_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_382_",
    className: "st22",
    d: "M36.8,18.6c0.2,0,0.5-0.1,0.8-0.1c0.4,0,0.7,0.1,0.9,0.3c0.2,0.2,0.3,0.4,0.3,0.7 c0,0.3-0.1,0.5-0.2,0.7c-0.2,0.2-0.6,0.4-1,0.4c-0.1,0-0.2,0-0.3,0v1.3h-0.4V18.6z M37.3,20.2c0.1,0,0.2,0,0.3,0 c0.5,0,0.8-0.2,0.8-0.7c0-0.4-0.3-0.6-0.8-0.6c-0.2,0-0.3,0-0.4,0V20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_387_",
    className: "st22",
    d: "M39.8,18.6v1.3h1.6v-1.3h0.4v3.2h-0.4v-1.5h-1.6v1.5h-0.4v-3.2H39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_391_",
    className: "st22",
    d: "M42.5,18.6c0.2,0,0.5-0.1,0.8-0.1c0.4,0,0.7,0.1,0.9,0.3c0.2,0.2,0.3,0.4,0.3,0.7 c0,0.3-0.1,0.5-0.2,0.7c-0.2,0.2-0.6,0.4-1,0.4c-0.1,0-0.2,0-0.3,0v1.3h-0.4V18.6z M42.9,20.2c0.1,0,0.2,0,0.3,0 c0.5,0,0.8-0.2,0.8-0.7c0-0.4-0.3-0.6-0.8-0.6c-0.2,0-0.3,0-0.4,0V20.2z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_473_",
    className: "st4",
    d: "M17.7,39.5h-5c-0.6,0-1-0.5-1-1V26.6c0-0.6,0.5-1,1-1h19.3c0.6,0,1-0.5,1-1V23 c0-0.6-0.5-1-1-1H17.2c-0.6,0-1-0.5-1-1v-1.7c0-0.6,0.5-1,1-1h6.1c0.9,0,1.6-0.7,1.7-1.6v-2.7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_472_",
    x: 16.7,
    y: 28,
    className: "st19",
    width: 30.7,
    height: 22.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_481_",
    className: "st33",
    x1: 22.3,
    y1: 28,
    x2: 22.3,
    y2: 50.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_480_",
    className: "st4",
    x1: 19.5,
    y1: 31.6,
    x2: 19.5,
    y2: 34.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_479_",
    className: "st4",
    x1: 19.5,
    y1: 37.9,
    x2: 19.5,
    y2: 41
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_478_",
    className: "st4",
    x1: 19.5,
    y1: 44.2,
    x2: 19.5,
    y2: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_477_",
    x: 24.2,
    y: 29.4,
    className: "st14",
    width: 21.9,
    height: 19
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_483_",
    className: "st4",
    points: "16.7,50 47.4,50 47.4,41  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_476_",
    className: "st4",
    points: "47.4,28 16.7,28 16.7,36.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_474_",
    className: "st19",
    d: "M51.9,49.1h-1.1l-0.4-2.4c0-0.1,0-0.1,0-0.2V24.2l1-2.1l1,2.1v22.4c0,0.1,0,0.1,0,0.2 L51.9,49.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_475_",
    className: "st34",
    points: "50.4,24.2 51.4,22.1 52.4,24.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_471_",
    className: "st4",
    d: "M51.9,49.1h-1.1l-0.4-2.4c0-0.1,0-0.1,0-0.2V24.2l1-2.1l1,2.1v22.4c0,0.1,0,0.1,0,0.2 L51.9,49.1z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_497_",
    className: "st13",
    d: "M47.3,25.7c0.9,0,1.5,0.7,1.5,1.5v15.3c0,0.9-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5v-3.8 c0-0.9-0.6-1.5-1.4-1.5s-1.4,0.7-1.4,1.5v1c0,0.9-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5v-6.1c0-0.9-0.5-1.5-1.2-1.5 c-0.7,0-1.2,0.6-1.2,1.4c0,0.8-0.5,1.4-1.2,1.4s-1.2-0.7-1.2-1.5v-6.1c0-0.9,0.7-1.5,1.5-1.5h2.3H47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_501_",
    className: "st4",
    d: "M40.2,39.8v-6.1c0-0.9-0.5-1.5-1.2-1.5c-0.7,0-1.2,0.6-1.2,1.4c0,0.8-0.5,1.4-1.2,1.4 s-1.2-0.7-1.2-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_502_",
    className: "st4",
    d: "M45.9,42.5v-3.8c0-0.9-0.6-1.5-1.4-1.5s-1.4,0.7-1.4,1.5v1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_500_",
    className: "st4",
    d: "M47.3,25.7c0.9,0,1.5,0.7,1.5,1.5v15.3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_491_",
    x: 22.4,
    y: 16.2,
    className: "st19",
    width: 3.5,
    height: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_489_",
    className: "st19",
    d: "M16.6,26.8c0-4,3.3-7.3,7.3-7.3c4,0,7.3,3.3,7.3,7.3H16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_493_",
    className: "st1",
    d: "M24.7,19.9c-3.9,0-7.1,3.1-7.3,6.9h-0.9c0-4,3.3-7.3,7.3-7.3c1.1,0,2.1,0.2,3,0.7 C26.2,20,25.5,19.9,24.7,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_482_",
    className: "st19",
    d: "M20.1,50.4h7.5c2.4,0,4.3-1.9,4.3-4.3V27.3c0-1.6-1.3-2.8-2.8-2.8h-9c-2.4,0-4.3,1.9-4.3,4.3 V46C15.7,48.4,17.7,50.4,20.1,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_494_",
    className: "st1",
    d: "M19.7,24.5h1.8c0.6,0.7,1,0.4,1,0.9v25h-2.9c-2.2,0-4-1.8-4-4V26.7 C15.7,24.5,17.5,24.5,19.7,24.5z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_498_",
    className: "st4",
    x1: 15.2,
    y1: 24.6,
    x2: 32.5,
    y2: 24.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_484_",
    className: "st4",
    x1: 17.4,
    y1: 50,
    x2: 29.4,
    y2: 50
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_488_",
    x: 23.3,
    y: 30.8,
    className: "st2",
    width: 8.6,
    height: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_490_",
    x: 24,
    y: 31.2,
    className: "st13",
    width: 7.9,
    height: 11.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_499_",
    className: "st1",
    d: "M25.1,18.2c0-0.5,0.4-0.8,0.8-0.8V19C25.4,19,25.1,18.6,25.1,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_485_",
    className: "st4",
    d: "M35.6,20.6c-0.2,0.3-0.2,0.7-0.2,1.1c0,1.5,1.2,2.6,2.6,2.6c1.4,0,2.5-1.1,2.6-2.5 c0.7,0.7,1.7,1.1,2.7,1.1c2.2,0,4-1.8,4-4s-1.8-4-4-4c-0.8,0-1.5,0.2-2.1,0.6c-0.5-1.1-1.6-1.9-2.9-1.9c-1.5,0-2.8,1.1-3.1,2.6 l-5.5,0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_487_",
    className: "st4",
    x1: 33.6,
    y1: 18.2,
    x2: 27.4,
    y2: 18.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_486_",
    className: "st4",
    d: "M42.9,17.2c1,0,1.8,0.8,1.8,1.8"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_623_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_508_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_518_",
    x: 12,
    y: 39.9,
    className: "st22",
    width: 40.1,
    height: 8.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_517_",
    x: 12,
    y: 39.9,
    className: "st23",
    width: 40.1,
    height: 3.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_516_",
    className: "st17",
    x1: 18,
    y1: 39.9,
    x2: 18,
    y2: 42.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_515_",
    className: "st17",
    x1: 12.5,
    y1: 39.9,
    x2: 12.5,
    y2: 42.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_514_",
    className: "st17",
    x1: 23.6,
    y1: 39.9,
    x2: 23.6,
    y2: 42.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_513_",
    className: "st17",
    x1: 29.2,
    y1: 39.9,
    x2: 29.2,
    y2: 42.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_512_",
    className: "st17",
    x1: 34.8,
    y1: 39.9,
    x2: 34.8,
    y2: 42.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_511_",
    className: "st17",
    x1: 46,
    y1: 39.9,
    x2: 46,
    y2: 42.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_510_",
    className: "st17",
    x1: 40.4,
    y1: 39.9,
    x2: 40.4,
    y2: 42.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_509_",
    className: "st17",
    x1: 51.5,
    y1: 39.9,
    x2: 51.5,
    y2: 42.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_505_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_506_",
    className: "st31",
    d: "M26.9,17.8h10.4c0.5,0,0.9-0.1,1.2-0.2h0.3l0.1,3.5h-0.3c-0.1-1-0.4-1.7-0.8-2 c-0.4-0.3-0.8-0.4-1.3-0.4h-2.8v11.8c0,0.4,0,0.7,0.1,1c0.1,0.3,0.3,0.5,0.5,0.7c0.3,0.2,0.7,0.3,1.2,0.3v0.3h-7v-0.3 c0.8,0,1.3-0.2,1.5-0.5c0.2-0.4,0.3-0.8,0.3-1.4V18.7h-2.8c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.3-0.6,0.9-0.9,1.9h-0.3l0.1-3.5h0.3 C26,17.7,26.4,17.8,26.9,17.8z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_503_",
    x: 19.1,
    y: 13.9,
    className: "st5",
    width: 2.2,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_539_",
    x: 42.9,
    y: 13.9,
    className: "st5",
    width: 2.2,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_541_",
    x: 19.1,
    y: 34.4,
    className: "st5",
    width: 2.2,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_540_",
    x: 42.9,
    y: 34.4,
    className: "st5",
    width: 2.2,
    height: 2.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_543_",
    className: "st18",
    x1: 20.1,
    y1: 14.9,
    x2: 41.9,
    y2: 14.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_545_",
    className: "st18",
    x1: 20.2,
    y1: 35.5,
    x2: 20.2,
    y2: 13.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_544_",
    className: "st18",
    x1: 44,
    y1: 35.9,
    x2: 44,
    y2: 14.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_542_",
    className: "st18",
    x1: 20.1,
    y1: 35.5,
    x2: 41.9,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_519_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_526_",
    className: "st21",
    d: "M45.8,50.2H13.9v-3.4h31.9l4.2,1.6c0.1,0,0.1,0.1,0,0.2L45.8,50.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_525_",
    x: 13.9,
    y: 46.8,
    className: "st8",
    width: 31.9,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_524_",
    x: 13.9,
    y: 46.8,
    className: "st9",
    width: 31.9,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_523_",
    x: 13.9,
    y: 46.7,
    className: "st21",
    width: 4,
    height: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_522_",
    className: "st17",
    d: "M45.8,50.2H13.9v-3.4h31.9l4.2,1.6c0.1,0,0.1,0.1,0,0.2L45.8,50.2z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_521_",
    className: "st17",
    x1: 17.8,
    y1: 46.8,
    x2: 17.8,
    y2: 49.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_520_",
    className: "st17",
    x1: 45.8,
    y1: 47,
    x2: 45.8,
    y2: 49.9
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_566_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_538_",
    x: 12,
    y: 14.4,
    className: "st3",
    width: 27.4,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_537_",
    x: 12.3,
    y: 11.7,
    className: "st14",
    width: 26.6,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_536_",
    x: 12.3,
    y: 11.7,
    className: "st4",
    width: 26.6,
    height: 4.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_529_",
    className: "st2",
    cx: 31.9,
    cy: 13.9,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_528_",
    className: "st2",
    cx: 33.8,
    cy: 13.9,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_527_",
    className: "st2",
    cx: 35.7,
    cy: 13.9,
    r: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_562_",
    className: "st4",
    x1: 32.6,
    y1: 27.4,
    x2: 32.6,
    y2: 31.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_568_",
    className: "st4",
    x1: 42.2,
    y1: 31.3,
    x2: 39.1,
    y2: 34.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_570_",
    className: "st4",
    x1: 40.7,
    y1: 30.4,
    x2: 43,
    y2: 32.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_571_",
    className: "st4",
    x1: 24.8,
    y1: 30.4,
    x2: 22.5,
    y2: 32.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_569_",
    className: "st4",
    x1: 23.4,
    y1: 31.3,
    x2: 26.5,
    y2: 34.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_546_",
    className: "st19",
    cx: 32.5,
    cy: 41,
    r: 11.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_560_",
    className: "st13",
    d: "M32.5,29.7c6.2,0,11.3,5.1,11.3,11.3H32.5V29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_561_",
    className: "st4",
    d: "M43.8,41c0-6.2-5.1-11.3-11.3-11.3h-0.4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_547_",
    className: "st5",
    cx: 32.5,
    cy: 31.6,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_548_",
    className: "st5",
    cx: 37.2,
    cy: 32.9,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_549_",
    className: "st5",
    cx: 40.6,
    cy: 36.3,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_550_",
    className: "st5",
    cx: 41.9,
    cy: 41,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_551_",
    className: "st5",
    cx: 40.7,
    cy: 45.6,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_552_",
    className: "st5",
    cx: 37.2,
    cy: 49.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_553_",
    className: "st5",
    cx: 32.6,
    cy: 50.3,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_554_",
    className: "st5",
    cx: 27.9,
    cy: 49.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_555_",
    className: "st5",
    cx: 24.4,
    cy: 45.7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_556_",
    className: "st5",
    cx: 23.2,
    cy: 41.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_557_",
    className: "st5",
    cx: 24.4,
    cy: 36.4,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_558_",
    className: "st5",
    cx: 27.8,
    cy: 32.9,
    r: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_563_",
    x: 30.7,
    y: 26.3,
    className: "st19",
    width: 3.8,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_559_",
    x: 30.7,
    y: 26.3,
    className: "st4",
    width: 3.8,
    height: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_565_",
    className: "st2",
    cx: 32.5,
    cy: 41,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_564_",
    className: "st4",
    cx: 32.5,
    cy: 41,
    r: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_567_",
    className: "st4",
    x1: 33.7,
    y1: 41,
    x2: 39.3,
    y2: 41
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_531_",
    className: "st4",
    x1: 14.3,
    y1: 19.7,
    x2: 24.8,
    y2: 19.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_530_",
    className: "st4",
    x1: 43,
    y1: 19.7,
    x2: 27.2,
    y2: 19.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_532_",
    className: "st4",
    x1: 36.3,
    y1: 21.8,
    x2: 20.5,
    y2: 21.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_533_",
    className: "st4",
    x1: 37.4,
    y1: 21.8,
    x2: 47.9,
    y2: 21.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_534_",
    className: "st4",
    x1: 31.5,
    y1: 24.3,
    x2: 52,
    y2: 24.3
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_535_",
    className: "st4",
    points: "12,24.3 12,35.4 21.2,35.4  "
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_572_",
    className: "st4",
    x1: 39.3,
    y1: 26.3,
    x2: 39.3,
    y2: 30.6
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_593_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_591_",
    className: "st3",
    d: "M34.5,43.6v5c0,1.5-1.2,2.8-2.8,2.8l0,0c-1.5,0-2.8-1.2-2.8-2.8v-5H34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_587_",
    className: "st4",
    d: "M34.5,43.6v5c0,1.5-1.2,2.8-2.8,2.8l0,0c-1.5,0-2.8-1.2-2.8-2.8v-5H34.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_584_",
    className: "st13",
    cx: 31.8,
    cy: 27.7,
    r: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_583_",
    x: 26.9,
    y: 31.7,
    className: "st13",
    width: 9.7,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_582_",
    x: 26.9,
    y: 42.2,
    className: "st19",
    width: 9.9,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_581_",
    x: 26.9,
    y: 42.2,
    className: "st4",
    width: 9.9,
    height: 2.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_580_",
    className: "st4",
    x1: 29.2,
    y1: 46.5,
    x2: 32.4,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_579_",
    className: "st4",
    x1: 31.7,
    y1: 48.1,
    x2: 34.8,
    y2: 48.1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_575_",
    className: "st5",
    points: "34,27.4 30.8,27.4 34,20 28.5,27.9 27.5,29.3 29.3,29.3 32.4,29.3 29.3,35.9  34.8,28.9 35.9,27.4  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1448_",
    className: "st4",
    d: "M45.7,34.4c0,0.8-1.7,0.8-1.7,1.7c0,0.8,1.7,0.8,1.7,1.7c0,0.8-1.7,0.8-1.7,1.7 c0,0.8,1.7,0.8,1.7,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_578_",
    className: "st4",
    d: "M21.8,44.8c0,0.7-1.4,0.7-1.4,1.4c0,0.7,1.4,0.7,1.4,1.4c0,0.7-1.4,0.7-1.4,1.4 c0,0.7,1.4,0.7,1.4,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_595_",
    className: "st4",
    d: "M40.5,12.7c0,0.7-1.4,0.7-1.4,1.4c0,0.7,1.4,0.7,1.4,1.4c0,0.7-1.4,0.7-1.4,1.4 c0,0.7,1.4,0.7,1.4,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_573_",
    className: "st4",
    d: "M17.4,22.8c0,0.8-1.7,0.8-1.7,1.7c0,0.8,1.7,0.8,1.7,1.7c0,0.8-1.7,0.8-1.7,1.7 c0,0.8,1.7,0.8,1.7,1.7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1452_",
    className: "st4",
    cx: 48.9,
    cy: 25.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_592_",
    className: "st4",
    cx: 42.8,
    cy: 46.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_586_",
    className: "st4",
    cx: 21.8,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_577_",
    className: "st4",
    cx: 49.4,
    cy: 15,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_576_",
    className: "st4",
    cx: 14.4,
    cy: 41.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_574_",
    className: "st4",
    cx: 21.8,
    cy: 38.5,
    r: 0.8
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_622_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_597_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_676_",
    x: 27.1,
    y: 45.1,
    className: "st20",
    width: 9.9,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_675_",
    x: 27.1,
    y: 45.1,
    className: "st35",
    width: 9.9,
    height: 2.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_674_",
    x: 27.1,
    y: 45.1,
    className: "st17",
    width: 9.9,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_673_",
    x: 15.6,
    y: 22.7,
    className: "st35",
    width: 32.7,
    height: 19.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_672_",
    x: 17.4,
    y: 24.6,
    className: "st21",
    width: 29.2,
    height: 15.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_671_",
    x: 17.6,
    y: 25.4,
    className: "st10",
    width: 13.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_598_",
    x: 32.5,
    y: 25.4,
    className: "st22",
    width: 13.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_668_",
    x: 15.6,
    y: 41.4,
    className: "st21",
    width: 32.7,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_667_",
    x: 15.9,
    y: 41.4,
    className: "st17",
    width: 32.1,
    height: 4.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_666_",
    className: "st17",
    x1: 25.2,
    y1: 51,
    x2: 39,
    y2: 51
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_594_",
    x: 20.6,
    y: 34.3,
    className: "st28",
    width: 22.9,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_599_",
    x: 20.6,
    y: 36.4,
    className: "st28",
    width: 22.9,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_600_",
    x: 20.6,
    y: 38.6,
    className: "st28",
    width: 22.9,
    height: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_653_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_655_",
    className: "st17",
    x1: 35.5,
    y1: 18.2,
    x2: 37.3,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_654_",
    className: "st17",
    x1: 35.5,
    y1: 20,
    x2: 37.3,
    y2: 18.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_616_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_618_",
    className: "st17",
    x1: 26.2,
    y1: 23.5,
    x2: 28,
    y2: 25.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_617_",
    className: "st17",
    x1: 26.2,
    y1: 25.3,
    x2: 28,
    y2: 23.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_610_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_612_",
    className: "st17",
    x1: 44.9,
    y1: 16.7,
    x2: 47.2,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_611_",
    className: "st17",
    x1: 44.9,
    y1: 19,
    x2: 47.2,
    y2: 16.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_619_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_621_",
    className: "st17",
    x1: 16.8,
    y1: 17.3,
    x2: 19.2,
    y2: 19.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_620_",
    className: "st17",
    x1: 16.8,
    y1: 19.6,
    x2: 19.2,
    y2: 17.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_613_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_615_",
    className: "st17",
    x1: 26.7,
    y1: 12.6,
    x2: 29.2,
    y2: 15.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_614_",
    className: "st17",
    x1: 26.7,
    y1: 15.1,
    x2: 29.2,
    y2: 12.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_596_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_636_",
    className: "st29",
    d: "M43.1,51.4h-7.8c-0.5,0-1-0.5-1-1V36.8c0-0.5,0.5-1,1-1h7.8c0.6,0,1,0.5,1,1v13.6 C44.1,51,43.6,51.4,43.1,51.4z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_637_",
    className: "st17",
    x1: 37.9,
    y1: 36.9,
    x2: 40.4,
    y2: 36.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_638_",
    x: 35,
    y: 37.7,
    className: "st21",
    width: 8.3,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_601_",
    x: 35.5,
    y: 38.6,
    className: "st8",
    width: 3.4,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_602_",
    x: 39.4,
    y: 38.6,
    className: "st22",
    width: 3.4,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_603_",
    x: 35.5,
    y: 46.5,
    className: "st28",
    width: 7.3,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_604_",
    x: 35.5,
    y: 48,
    className: "st28",
    width: 7.3,
    height: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_607_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_605_",
    className: "st17",
    points: "22.3,31.8 23.8,30.2 25.4,31.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_609_",
    className: "st17",
    points: "38.1,30.2 39.6,31.8 41.2,30.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_608_",
    className: "st17",
    d: "M31.8,23c2.2,0,4.2,0.9,5.6,2.3c1.4,1.4,2.3,3.4,2.3,5.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_606_",
    className: "st17",
    d: "M31.8,38.9c-2.2,0-4.2-0.9-5.6-2.3c-1.4-1.4-2.3-3.4-2.3-5.6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_625_",
    className: "st4",
    d: "M35.5,30.3l-0.7,0c-0.1-0.4-0.2-0.7-0.4-1l0.5-0.5c0.2-0.2,0.2-0.5,0-0.7l-0.4-0.4 c-0.2-0.2-0.5-0.2-0.7,0l-0.5,0.5c-0.3-0.2-0.7-0.3-1-0.4V27c0-0.3-0.2-0.5-0.5-0.5h-0.5c-0.3,0-0.5,0.2-0.5,0.5v0.7 c-0.4,0.1-0.7,0.2-1,0.4l-0.5-0.5c-0.2-0.2-0.5-0.2-0.7,0L28.2,28c-0.2,0.2-0.2,0.5,0,0.7l0.5,0.5c-0.2,0.3-0.4,0.7-0.4,1l-0.7,0 c-0.3,0-0.5,0.2-0.5,0.5l0,0.5c0,0.3,0.2,0.5,0.5,0.5l0.7,0c0.1,0.4,0.2,0.7,0.4,1l-0.5,0.5c-0.2,0.2-0.2,0.5,0,0.7l0.4,0.4 c0.2,0.2,0.5,0.2,0.7,0l0.5-0.5c0.3,0.2,0.7,0.4,1,0.4l0,0.7c0,0.3,0.2,0.5,0.5,0.5l0.5,0c0.3,0,0.5-0.2,0.5-0.5l0-0.7 c0.4-0.1,0.7-0.2,1-0.4l0.5,0.5c0.2,0.2,0.5,0.2,0.7,0l0.4-0.4c0.2-0.2,0.2-0.5,0-0.7l-0.5-0.5c0.2-0.3,0.3-0.7,0.4-1l0.7,0 c0.3,0,0.5-0.2,0.5-0.5v-0.5C36,30.5,35.8,30.3,35.5,30.3z M31.5,32.5c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5 c0.8,0,1.5,0.7,1.5,1.5C33,31.8,32.3,32.5,31.5,32.5z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_699_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_624_",
    className: "st14",
    d: "M46.5,52H13.7V31.6h36.6v16.6C50.3,50.2,49.1,52,46.5,52z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_629_",
    className: "st4",
    points: "38.3,52.3 13.7,52.3 13.7,31.5 21.9,31.5  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_631_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_634_",
    className: "st16",
    d: "M22.5,40.8h-4.8v-3.6h4.8V40.8z M18,40.5h4.2v-3H18V40.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_650_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_652_",
    className: "st16",
    d: "M28.4,40.8h-4.8v-3.6h4.8V40.8z M23.9,40.5h4.2v-3h-4.2V40.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_658_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_659_",
    className: "st16",
    d: "M34.2,40.8h-4.8v-3.6h4.8V40.8z M29.7,40.5h4.2v-3h-4.2V40.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_662_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_663_",
    className: "st16",
    d: "M40.1,40.8h-4.8v-3.6h4.8V40.8z M35.6,40.5h4.2v-3h-4.2V40.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_669_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_670_",
    className: "st16",
    d: "M46,40.8h-4.8v-3.6H46V40.8z M41.5,40.5h4.2v-3h-4.2V40.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_695_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_696_",
    className: "st16",
    d: "M22.5,46.8h-4.8v-3.6h4.8V46.8z M18,46.5h4.2v-3H18V46.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_691_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_692_",
    className: "st16",
    d: "M28.4,46.8h-4.8v-3.6h4.8V46.8z M23.9,46.5h4.2v-3h-4.2V46.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_687_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_688_",
    className: "st16",
    d: "M34.2,46.8h-4.8v-3.6h4.8V46.8z M29.7,46.5h4.2v-3h-4.2V46.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_683_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_684_",
    className: "st16",
    d: "M40.1,46.8h-4.8v-3.6h4.8V46.8z M35.6,46.5h4.2v-3h-4.2V46.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_679_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_680_",
    className: "st16",
    d: "M46,46.8h-4.8v-3.6H46V46.8z M41.5,46.5h4.2v-3h-4.2V46.5z"
  })), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_630_",
    className: "st18",
    x1: 17.7,
    y1: 42.1,
    x2: 43.4,
    y2: 42.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_633_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_649_",
    className: "st17",
    x1: 30.3,
    y1: 15.9,
    x2: 30.3,
    y2: 20.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_648_",
    className: "st28",
    d: "M23.4,41.6L30.9,22c0.1-0.4-0.1-0.6-0.4-0.6h-1.7c-0.4,0-0.7,0.3-0.8,0.7L23.4,41.6 C23.3,42,23.3,42,23.4,41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_647_",
    className: "st28",
    d: "M37.7,41.6L30.2,22c-0.1-0.4,0.1-0.6,0.4-0.6h1.7c0.4,0,0.8,0.3,0.8,0.7L37.7,41.6 C37.8,42,37.8,42,37.7,41.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_646_",
    className: "st22",
    cx: 30.3,
    cy: 20.8,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_645_",
    className: "st17",
    cx: 30.3,
    cy: 20.8,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_644_",
    className: "st32",
    cx: 30.3,
    cy: 20.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_643_",
    x: 29.3,
    y: 11.7,
    className: "st36",
    width: 1.9,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_642_",
    x: 29.3,
    y: 11.7,
    className: "st35",
    width: 1,
    height: 5.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_641_",
    className: "st17",
    d: "M37,29.9c-1.6,1.6-3.9,2.7-6.4,2.7s-4.8-1-6.4-2.7"
  })), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_651_",
    className: "st4",
    x1: 38,
    y1: 31.6,
    x2: 43.4,
    y2: 31.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_628_",
    className: "st15",
    d: "M44.4,26.2c2.2-1.4,5.9-0.4,5.9,3.3v19c-0.3-3.7-4.3-4.2-5.9-2.8V26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_632_",
    className: "st24",
    d: "M48.6,45.5c0.8,0.5,1.5,1.4,1.7,2.7c0,0,0,0,0,0V29.5c0-1.6-0.7-2.6-1.6-3.3 c0,0-0.1,0-0.1,0.1V45.5z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_702_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_726_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_736_",
    x: 12.7,
    y: 15.2,
    className: "st22",
    width: 7,
    height: 33.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_735_",
    x: 12.7,
    y: 15.2,
    className: "st23",
    width: 3.1,
    height: 33.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_734_",
    className: "st17",
    x1: 12.7,
    y1: 43.7,
    x2: 14.9,
    y2: 43.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_733_",
    className: "st17",
    x1: 12.7,
    y1: 48.4,
    x2: 14.9,
    y2: 48.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_732_",
    className: "st17",
    x1: 12.7,
    y1: 39,
    x2: 14.9,
    y2: 39
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_731_",
    className: "st17",
    x1: 12.7,
    y1: 34.3,
    x2: 14.9,
    y2: 34.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_730_",
    className: "st17",
    x1: 12.7,
    y1: 29.7,
    x2: 14.9,
    y2: 29.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_729_",
    className: "st17",
    x1: 12.7,
    y1: 20.3,
    x2: 14.9,
    y2: 20.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_728_",
    className: "st17",
    x1: 12.7,
    y1: 25,
    x2: 14.9,
    y2: 25
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_727_",
    className: "st17",
    x1: 12.7,
    y1: 15.6,
    x2: 14.9,
    y2: 15.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_704_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_714_",
    className: "st21",
    d: "M51.2,20.4v26.8h-2.8V20.4l1.3-3.5c0-0.1,0.1-0.1,0.2,0L51.2,20.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_713_",
    x: 48.4,
    y: 20.4,
    className: "st8",
    width: 2.8,
    height: 26.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_712_",
    x: 48.4,
    y: 20.4,
    className: "st9",
    width: 1.4,
    height: 26.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_711_",
    x: 48.3,
    y: 43.9,
    className: "st21",
    width: 3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_710_",
    className: "st17",
    d: "M51.2,20.4v26.8h-2.8V20.4l1.3-3.5c0-0.1,0.1-0.1,0.2,0L51.2,20.4z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_709_",
    className: "st17",
    x1: 48.4,
    y1: 43.9,
    x2: 50.9,
    y2: 43.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_708_",
    className: "st17",
    x1: 48.5,
    y1: 20.4,
    x2: 51,
    y2: 20.4
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_707_",
    className: "st3",
    points: "26.9,15.3 21.6,20.4 21.6,48.5 46.6,48.5 46.6,15.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_706_",
    className: "st14",
    points: "26.9,15.3 21.6,20.4 26.9,20.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_705_",
    className: "st4",
    points: "27.1,15.3 27.1,20.7 21.6,20.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_701_",
    className: "st13",
    points: "38.4,23.7 33.3,32.4 43.4,32.4 38.4,23.7 33.3,32.4 43.4,32.4  "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_700_",
    className: "st14",
    cx: 32.6,
    cy: 33.8,
    r: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_703_",
    x: 24.9,
    y: 33.8,
    className: "st13",
    width: 7.8,
    height: 7.8
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_738_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_751_",
    className: "st14",
    points: "35.7,50.2 32.1,48.8 28.5,50.2 28.5,39 35.7,39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_897_",
    className: "st37",
    points: "35.7,50.2 32.1,48.8 28.5,50.2 28.5,39 35.7,39  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_715_",
    className: "st13",
    d: "M39.6,43.9l-7.2-3.7c-0.1-0.1-0.3-0.1-0.4,0l-7.1,3.9c-0.4,0.2-0.8-0.1-0.7-0.5l1.3-8 c0-0.2,0-0.3-0.1-0.4l-5.9-5.6c-0.3-0.3-0.1-0.8,0.3-0.8l8-1.3c0.2,0,0.3-0.1,0.4-0.3l3.5-7.3c0.2-0.4,0.7-0.4,0.9,0l3.7,7.2 c0.1,0.1,0.2,0.2,0.4,0.3l8,1.1c0.4,0.1,0.6,0.5,0.3,0.8L39,35c-0.1,0.1-0.2,0.3-0.1,0.4l1.5,8C40.4,43.7,40,44.1,39.6,43.9z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_717_",
    className: "st4",
    x1: 32,
    y1: 13.8,
    x2: 32,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_716_",
    className: "st4",
    x1: 36.9,
    y1: 14.4,
    x2: 36.1,
    y2: 17.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_718_",
    className: "st4",
    x1: 41.5,
    y1: 16.3,
    x2: 39.8,
    y2: 19.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_719_",
    className: "st4",
    x1: 45.4,
    y1: 19.4,
    x2: 43.1,
    y2: 21.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_720_",
    className: "st4",
    x1: 48.4,
    y1: 23.3,
    x2: 45.6,
    y2: 24.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_721_",
    className: "st4",
    x1: 50.3,
    y1: 27.9,
    x2: 47.1,
    y2: 28.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_722_",
    className: "st4",
    x1: 50.9,
    y1: 32.8,
    x2: 47.6,
    y2: 32.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_723_",
    className: "st4",
    x1: 50.2,
    y1: 37.7,
    x2: 47.1,
    y2: 36.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_724_",
    className: "st4",
    x1: 48.3,
    y1: 42.2,
    x2: 45.5,
    y2: 40.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_725_",
    className: "st4",
    x1: 45.2,
    y1: 46.1,
    x2: 43,
    y2: 43.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_737_",
    className: "st4",
    x1: 41.3,
    y1: 49.1,
    x2: 39.7,
    y2: 46.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_741_",
    className: "st4",
    x1: 22.4,
    y1: 48.9,
    x2: 24,
    y2: 46.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_742_",
    className: "st4",
    x1: 18.5,
    y1: 45.8,
    x2: 20.8,
    y2: 43.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_743_",
    className: "st4",
    x1: 15.5,
    y1: 41.9,
    x2: 18.4,
    y2: 40.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_744_",
    className: "st4",
    x1: 13.7,
    y1: 37.3,
    x2: 16.8,
    y2: 36.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_745_",
    className: "st4",
    x1: 13.1,
    y1: 32.4,
    x2: 16.4,
    y2: 32.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_746_",
    className: "st4",
    x1: 13.8,
    y1: 27.5,
    x2: 17,
    y2: 28.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_747_",
    className: "st4",
    x1: 15.8,
    y1: 23,
    x2: 18.6,
    y2: 24.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_748_",
    className: "st4",
    x1: 18.9,
    y1: 19.1,
    x2: 21.1,
    y2: 21.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_749_",
    className: "st4",
    x1: 22.9,
    y1: 16.1,
    x2: 24.4,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_750_",
    className: "st4",
    x1: 27.5,
    y1: 14.3,
    x2: 28.2,
    y2: 17.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1211_"
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_739_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1002_",
    className: "st36",
    points: "34.2,26.7 34.2,26.7 34.2,26.7  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1001_",
    className: "st36",
    d: "M34.2,26.6C34.2,26.6,34.2,26.6,34.2,26.6C34.2,26.6,34.1,26.6,34.2,26.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1000_",
    className: "st28",
    cx: 24.4,
    cy: 34.2,
    r: 12.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_782_",
    className: "st8",
    d: "M35.9,30.5C36,30.5,35.8,30.5,35.9,30.5L35.9,30.5z M36,30.7C35.8,31.1,36,30.8,36,30.7 L36,30.7z M30.9,29.5c0,0-2.2-2.1-0.6-2.2c0,0,0-0.1,0-0.1c-0.1,0,0,0,0,0.1c0-0.1-0.3,0-0.5,0c-0.1,0,0.1-0.1,0-0.1 c0,0,0-0.1,0-0.1c0.1,0,0.1,0,0-0.1c0,0,0.3-0.3,0.4-0.1c0-0.1-0.1-0.1,0-0.1c0-0.1-1.2-1.3-2-1.8c0,0,0,0-0.1,0 c-0.2-0.2-0.4-0.3-0.6-0.3c0.1,0,0-0.1,0-0.1c1.3,0.3,2-1.2,3-0.8c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0.1 c-0.1-0.2,3.3,2.2,3,2.8c0,0,0,0,0,0c0,0,0,0-0.1,0.1c0.1,0.1,0.1,0.1,0,0.1c0.2,0.1,0.2,0,0.1,0c0.4,0.1,0.3,0.4,0.3,0.6 c0-0.2-1.3,0.1-0.1,0.2C32,27.4,31.6,28.8,30.9,29.5z M30.2,26.8C30.3,26.8,30.3,26.7,30.2,26.8L30.2,26.8z M30.2,27 C30.2,27,30.4,26.9,30.2,27L30.2,27z M29.9,27.9C30,27.9,29.9,27.9,29.9,27.9L29.9,27.9z M30,27.6C30.1,27.5,30.1,27.5,30,27.6 L30,27.6z M30.3,27.5C30,27.5,30.3,27.5,30.3,27.5L30.3,27.5z M30.2,27.8C30.2,27.8,30.3,27.9,30.2,27.8L30.2,27.8z M30.3,27.6 C30.5,27.8,30.1,27.4,30.3,27.6L30.3,27.6z M33.6,26.8C33.6,26.8,33.7,26.8,33.6,26.8L33.6,26.8z M33.4,27.4 C33.6,27.3,33.2,27.4,33.4,27.4L33.4,27.4z M33.5,27.5C33.7,27.4,33.3,27.5,33.5,27.5L33.5,27.5z M33.6,26.9 C33.5,26.9,33.8,26.9,33.6,26.9L33.6,26.9z M34.2,27.7C34.2,27.7,34.1,27.7,34.2,27.7L34.2,27.7z M33.9,26.8 C33.9,26.8,33.9,26.8,33.9,26.8C33.9,26.8,33.9,26.8,33.9,26.8z M33.4,27.4C33.5,27.4,33.4,27.4,33.4,27.4L33.4,27.4z M33.9,26.8 C33.9,26.8,33.9,26.8,33.9,26.8C33.9,26.8,33.9,26.8,33.9,26.8C33.9,26.8,33.9,26.8,33.9,26.8z M30.1,26.8 C30.3,26.7,30.1,26.7,30.1,26.8L30.1,26.8z M17.1,27.6C17.1,27.6,17.2,27.5,17.1,27.6C17.2,27.5,17.1,27.6,17.1,27.6z M14.8,28.2 C15.1,28.3,14.4,28.2,14.8,28.2L14.8,28.2z M17.3,27.5C17.3,27.5,17.3,27.5,17.3,27.5C17.3,27.5,17.3,27.5,17.3,27.5z M23.4,24.6 C23.5,24.7,23.4,24.5,23.4,24.6L23.4,24.6z M23.6,24.7C23.7,24.7,23.7,24.7,23.6,24.7C23.6,24.7,23.6,24.7,23.6,24.7 C23.6,24.7,23.6,24.7,23.6,24.7C23.5,24.7,23.5,24.7,23.6,24.7C23.4,24.7,23.5,24.7,23.6,24.7C23.6,24.7,23.6,24.7,23.6,24.7z  M23.6,24.7C23.7,24.7,23.7,24.7,23.6,24.7L23.6,24.7z M23.5,24C23.6,24,23.6,24,23.5,24L23.5,24z M23.5,24 C23.6,24,23.7,24,23.5,24L23.5,24z M23.6,23.9C23.6,23.9,23.6,23.9,23.6,23.9L23.6,23.9z M23.4,23.9C24,24.2,24.1,24.2,23.4,23.9 L23.4,23.9z M23.4,23.9C23.5,23.9,23.4,23.8,23.4,23.9L23.4,23.9z M27.7,28.9C27.7,29,27.8,28.9,27.7,28.9 C27.7,28.9,27.7,28.9,27.7,28.9z M23.4,24.4C23.4,24.4,23,24.4,23.4,24.4C23.4,24.4,23.4,24.4,23.4,24.4z M23.9,24.3 c0,0-0.1-0.1-0.1-0.1C23.7,24.2,23.8,24.3,23.9,24.3z M24.2,23.7C24.5,23.8,23.9,23.6,24.2,23.7L24.2,23.7z M26.8,25.1 C26.7,25.1,26.7,25.1,26.8,25.1C26.7,25.2,26.8,25.2,26.8,25.1z M25.6,34.5C25.6,34.5,25.6,34.5,25.6,34.5 C25.6,34.5,25.6,34.5,25.6,34.5z M24,24.6C24.1,24.7,23.8,24.6,24,24.6L24,24.6z M24,24.8C23.9,24.8,24,24.8,24,24.8L24,24.8z  M23.9,24.6C23.8,24.7,23.9,24.6,23.9,24.6L23.9,24.6z M23.7,24.6C23.3,24.8,25,24.3,23.7,24.6L23.7,24.6z M24,24.7 C24,24.7,24,24.7,24,24.7C23.8,24.6,24.1,24.7,24,24.7z M28.9,23.8c-0.1,0-0.2,0-0.3,0C29,23.9,28.6,23.8,28.9,23.8z M26.2,23.5 C26.2,23.5,26.2,23.5,26.2,23.5C26.2,23.5,26.2,23.5,26.2,23.5z M25.4,23.3C25.3,23.3,25.3,23.3,25.4,23.3 C25.3,23.3,25.4,23.3,25.4,23.3z M26.9,23.7C26.9,23.7,26.9,23.7,26.9,23.7C26.9,23.7,26.9,23.7,26.9,23.7z M26.9,23.7 C26.9,23.7,26.9,23.7,26.9,23.7C26.9,23.7,26.9,23.7,26.9,23.7C26.9,23.7,26.9,23.7,26.9,23.7C26.9,23.7,26.9,23.7,26.9,23.7z  M24.6,23.7c-0.3-0.5,1.4,0,2,0.3c0-0.1-0.3-0.2-0.1-0.2c-0.1,0-0.1-0.1,0-0.1c-0.1,0-0.1,0,0.1-0.1c-0.7,0.2-0.9-0.4-1.1-0.4 c0.1,0,0.1,0,0-0.1c0,0,0,0-0.1-0.1c0.2,0.1,4.2-0.4,4.1,0.4c0,0,0,0,0,0.1c0,0.2-0.9,0.1-1,0.1c0.1,0,0.1,0,0.2,0.1 c-0.6,0-0.9,0.4-1.5,0.4c-0.1,0,0.2,0.1,0.1,0c0.5,0.3-0.8,1-1.8,0.6c0,0,0-0.1,0-0.2c0-0.3,0.5,0,0.7-0.1c-0.1,0-0.1,0-0.1,0 c-0.1,0,0,0,0.1-0.1c-0.1,0-0.4-0.1-0.3-0.2C25.2,24.4,24.9,24.2,24.6,23.7C24.6,23.7,24.6,23.7,24.6,23.7 C24.6,23.7,24.6,23.7,24.6,23.7z M27.4,23.2C27.4,23.2,27.3,23.3,27.4,23.2L27.4,23.2z M26.1,23.3C26.1,23.2,26.1,23.3,26.1,23.3 L26.1,23.3z M26.2,23.5C26.1,23.5,26.1,23.5,26.2,23.5C25.8,23.5,26,23.7,26.2,23.5z M27.1,24.3C27,24.3,27,24.3,27.1,24.3 L27.1,24.3z M27,24.3C27,24.3,27,24.3,27,24.3L27,24.3z M26.9,23.7C26.9,23.8,26.9,23.8,26.9,23.7C27,23.7,27,23.7,26.9,23.7 C26.9,23.7,26.9,23.7,26.9,23.7C26.9,23.7,26.9,23.7,26.9,23.7C26.9,23.7,26.9,23.7,26.9,23.7c0,0-0.1,0-0.2,0.1 C26.5,23.9,26.8,23.8,26.9,23.7z M26.5,24.7C26.5,24.7,26.4,24.7,26.5,24.7L26.5,24.7z M26.1,24.6C26.1,24.6,26.1,24.6,26.1,24.6 L26.1,24.6z M26.1,24.4C26.1,24.4,26.1,24.4,26.1,24.4L26.1,24.4z M26,24.2C25.9,24.2,26.1,24.2,26,24.2L26,24.2z M26.8,23.8 C26.7,23.8,26.8,23.8,26.8,23.8L26.8,23.8z M25.2,24.6C25.2,24.6,25.2,24.6,25.2,24.6C25.3,24.6,25.6,24.5,25.2,24.6z M23.7,26.6 C23.9,26.6,23.6,26.5,23.7,26.6C23.7,26.6,23.7,26.6,23.7,26.6z M25.7,27.4c0,0,0,0.1,0.1,0.1C25.9,27.5,25.7,27.5,25.7,27.4z  M22.2,24.1C22.2,24.1,22,24.1,22.2,24.1L22.2,24.1z M27.5,28.5C27.5,28.4,27.4,28.4,27.5,28.5C27.4,28.4,27.5,28.5,27.5,28.5z  M22.4,24.2C21.9,24.1,23.1,24.4,22.4,24.2L22.4,24.2z M23.5,26.6C23.5,26.6,23.5,26.5,23.5,26.6C23.4,26.6,23.5,26.6,23.5,26.6z  M27.7,24.9c0,0,0.1,0,0.1,0C27.8,24.9,27.7,24.9,27.7,24.9z M26.5,26.9c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0,0c0,0,0,0,0,0 C26.6,26.8,26.6,26.8,26.5,26.9C26.5,26.9,26.5,26.9,26.5,26.9C26.5,26.9,26.5,26.9,26.5,26.9C26.5,26.9,26.5,26.9,26.5,26.9z  M26.2,35.1C26.2,35.1,26.1,35.1,26.2,35.1C26.1,35.1,26.2,35.1,26.2,35.1z M36,31.3C36.1,31.3,36.1,31.2,36,31.3 C36,31.2,36,31.3,36,31.3z M35.9,30.8C35.9,30.7,35.9,30.8,35.9,30.8L35.9,30.8z M25.6,31.3c0,0-0.2,0-0.2,0 C25.4,31.3,25.5,31.4,25.6,31.3z M24.5,45.4C24.5,45.3,24.5,45.3,24.5,45.4C24.6,45.4,24.5,45.3,24.5,45.4z M24.8,44.1 C24.8,44.2,24.9,44.3,24.8,44.1L24.8,44.1z M24.7,45.6c0,0-0.2-0.1-0.1-0.1C24.6,45.6,24.7,45.6,24.7,45.6z M27,35.6 C27.4,35.7,27,35.6,27,35.6L27,35.6z M27,35.6C26.9,35.6,27,35.6,27,35.6L27,35.6z M25.8,35.2C24.4,34.4,25.1,34.9,25.8,35.2 L25.8,35.2z M25.8,35.2C25.9,35.2,25.8,35.2,25.8,35.2L25.8,35.2z M24.9,34.7C25.2,34.6,25,34.6,24.9,34.7L24.9,34.7z M35.2,31.5 C36.8,31.4,35.2,31.5,35.2,31.5C35.2,31.5,35.2,31.5,35.2,31.5z M35.8,30.6C35.9,30.7,35.9,30.6,35.8,30.6 C35.8,30.6,35.8,30.6,35.8,30.6z M36,31.4C36.1,31.9,36.2,32.2,36,31.4L36,31.4z M34.1,26.8C34.1,26.9,34.1,26.8,34.1,26.8 L34.1,26.8z M36.3,34.2c-0.7,0.6,0.2-1,0.1-2c-0.1,0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0.1-0.2,0.1c0,0.8-0.8,2-2,3.5 c-0.3,0.4-0.2,1-0.3,1.4C32.4,40.9,37.5,33.1,36.3,34.2z M17.1,27.5c0,0,0.1-0.1,0.1-0.1C17.2,27.5,17.1,27.5,17.1,27.5z  M15.2,33.7C15.2,33.7,15.2,33.7,15.2,33.7C15.4,33.8,15.2,33.7,15.2,33.7z M16.5,27.8C16.6,28,16.4,27.6,16.5,27.8L16.5,27.8z  M14.9,28.2C15.1,28.2,14.4,28.1,14.9,28.2L14.9,28.2z M14.5,28.3C14.5,28.4,14.5,28.5,14.5,28.3L14.5,28.3z M14.5,28.3 C14.5,28.3,14.5,28.3,14.5,28.3L14.5,28.3z M19.2,29.3C19.1,29.2,19.2,29.3,19.2,29.3L19.2,29.3z M19.2,29.3 C18.7,29.1,18.9,29.2,19.2,29.3L19.2,29.3z M23.5,24.9C23.3,24.9,23.3,25,23.5,24.9L23.5,24.9z M27.8,28.8 C27.8,28.8,27.7,28.8,27.8,28.8C27.7,28.9,27.8,28.9,27.8,28.8z M23.8,24.2c-0.1,0,0,0.1,0.1,0.1C23.9,24.2,23.8,24.1,23.8,24.2z  M28.2,28.7C28.3,28.5,28.1,29,28.2,28.7L28.2,28.7z M26.8,25.1C26.8,25.1,26.7,25.1,26.8,25.1C26.7,25.1,26.8,25.1,26.8,25.1z  M24.4,24C25,24.6,24.8,24.4,24.4,24L24.4,24z M25.3,24.7C25.3,24.8,25.4,24.7,25.3,24.7C25.3,24.6,25.3,24.7,25.3,24.7z  M23.7,26.4C23.8,26.4,23.6,26.5,23.7,26.4L23.7,26.4z M24.7,24.8C24.6,24.8,24.7,24.9,24.7,24.8C24.7,24.9,24.7,24.8,24.7,24.8z  M23.7,25.4c-0.7,0.3,0.9,0.6,0.6,0.3C24.1,25.3,24.1,25.3,23.7,25.4z M26.2,28.2C26.2,28.2,26.2,28.2,26.2,28.2 C26.1,28.2,26.4,28.3,26.2,28.2z M24.8,25C24.8,25,24.8,25,24.8,25C24.4,24.6,24.9,25.1,24.8,25z M25.7,27.5 C25.7,27.5,25.6,27.4,25.7,27.5C25.6,27.4,25.6,27.5,25.7,27.5z M25.9,28.1c0,0.1,0,0.1-0.1,0.1c-0.1,0.1-0.1,0.1,0,0 c0,0.1,0,0.1,0,0c0.1,0,0.1-0.1,0.3-0.2c0,0-0.2,0.1-0.3,0.2C25.9,28.2,25.9,28.1,25.9,28.1z M25.2,24.9c0.2,0.1,0.4,0.2,1.2,0.3 C26.1,25.1,25.7,25,25.2,24.9C25.3,24.9,25.3,24.9,25.2,24.9c0,0-0.1,0-0.1,0C25.1,24.9,25.2,24.9,25.2,24.9 C25.2,24.9,25.2,24.9,25.2,24.9C25.2,24.9,25.2,24.9,25.2,24.9z M26.7,25.2C26.7,25.2,26.6,25.2,26.7,25.2L26.7,25.2z M24.4,24.6 c0.3,0.1,0.5,0.2,0.7,0.3c-0.2-0.1-0.4-0.1-0.6-0.1C24.6,24.7,24.5,24.7,24.4,24.6C24.4,24.6,24.5,24.6,24.4,24.6z M24.8,24.8 C25,24.8,24.8,24.8,24.8,24.8L24.8,24.8z M26.4,25.2c0.1,0,0.2,0,0.2,0C26.6,25.2,26.5,25.2,26.4,25.2z M22,24.4 C21.9,24.4,22,24.4,22,24.4L22,24.4z M23.2,24.6c-0.5-0.3-0.7-0.1-1.2-0.2c0,0-0.1,0-0.1,0c0,0-0.9-0.1-0.9-0.1 c0.6,0.1,0.9,0.1,0.9,0.1C20.6,24.6,23.4,24.7,23.2,24.6z M26.6,28.1C26.5,28.1,26.4,28.3,26.6,28.1L26.6,28.1z M22.1,24.2 C22,24.2,22.1,24.3,22.1,24.2C22.2,24.3,22.2,24.2,22.1,24.2z M27.8,24.9c0,0-0.1,0-0.1,0C27.7,24.8,27.8,24.9,27.8,24.9z  M26.5,26.9C26.5,26.9,26.5,26.9,26.5,26.9L26.5,26.9z M26.2,35C26.2,35,26.2,35,26.2,35C26.1,35,26.2,35.1,26.2,35z M29.5,31.4 C29.4,31.4,29.5,31.3,29.5,31.4L29.5,31.4z M29.4,31.4C29.4,31.4,29.5,31.4,29.4,31.4C29.5,31.3,29.5,31.4,29.4,31.4z M33.9,29 c0,0.1,0.9,0.2,1.1,0c0.5-0.6-0.7-0.4-0.8-0.4C33.6,28.2,33.9,28.9,33.9,29z M36.1,31.2C36.1,31.2,36.1,31.1,36.1,31.2 C36.1,31.2,36.1,31.2,36.1,31.2z M36,30.6C36,30.6,35.9,30.6,36,30.6C36,30.6,36,30.6,36,30.6z M35.9,30.7 C36,30.7,36,30.7,35.9,30.7L35.9,30.7z M24.8,44.1C24.7,44,25,44.1,24.8,44.1L24.8,44.1z M15.1,28.1 C15.2,28.1,15.2,28.1,15.1,28.1L15.1,28.1z M28,31.5C28,31.5,28,31.5,28,31.5L28,31.5z M19.7,25.8C19.8,25.7,19.5,25.9,19.7,25.8 L19.7,25.8z M28.3,31.6c-0.1-0.1-0.2-0.1-0.3-0.1C28.1,31.6,28.1,31.7,28.3,31.6z M26.4,26.7C26.5,26.7,26.1,26.7,26.4,26.7 C26.3,26.7,26.3,26.7,26.4,26.7z M30.8,39.3c0.8,2.3-5.8,4.4-5.4,6.3c-0.5,0-0.4,0.1-0.8-0.2c0.1,0.1,0-0.2,0-0.4c0,0,0,0,0,0 c0,0,0-0.1,0,0c0,0,0.1-0.1,0.1-0.1c0,0-0.1-0.1,0-0.1c0-0.1-0.1,0-0.1,0c0,0,0,0,0,0c0,0.1,0,0.1,0,0.1c0-0.1,0-0.1,0,0 c0,0,0,0,0,0c0-0.1,0-0.1,0-0.1c0,0,0,0,0,0c-0.3-0.2,0.7-0.7,0.5-1.2c0.8,0.1-0.4-7.2,0.1-7.1c-0.7-0.2-3.8-1.8-4-3.4 c0,0-0.1-0.5-0.3-0.4c0,0.3,0.7,1.2,0.5,1.3c0.1,0-1.8-4.3-2.3-5.5c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0-0.1-0.2-0.1,0 c0,0,0-0.1,0-0.1c0.1,0-0.1-0.5,0-0.6c-0.1,0.1,0,0.3-0.1,0.4c0.1-0.1,0-0.4-0.1-0.5c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0h0 c0,0,0,0,0,0c0,0.1,0,0.3,0,0.4c-0.3-0.5-1.9-1.3-2-1.2c-0.4,0.2-0.9,1.1-1.4,0.9c0,0,0-0.1-0.1,0c0,0,0,0,0,0c0,0-0.1,0-0.1,0.1 c0.1,0,0.6-0.4,0.7-0.6c0,0,0,0,0-0.1c-0.1,0-0.2-0.1-0.1,0c-0.6-0.2-1.4-0.5-0.2-1.2c0.3,0.2,2.1-0.3,3.9-0.5c0,0,0,0.2,0,0 c0,0,0,0,0,0c1.3-0.1,2.6,0,3.2,0.9c0,0,0,0.1,0,0.1c0,0,0-0.1,0,0c-0.1-0.2-0.2-0.5,0.3-0.4c-0.2-0.1-2.5-0.6-0.9-0.4 c-0.3-0.1-1.2-0.4-0.5-0.7c-0.7,0.2-0.5,0.2-1.2,0.1c0.1,0,0.1-0.1,0-0.1c0.1,0,0.3-0.5,0.3-0.5c0.1,0,0.1,0,0-0.1 c0.5,0,2.3,0.6,2.6,0.6c0,0.2-0.1,1,0.4,1c-0.4,0,0.2,0.2-0.7,0.1c0.8,0.6,0.9,0.1,0.9,0.1c0,0,0,0,0-0.1c0.1,0,0.2,0,0.2-0.1 c0.3-0.1,0.2,0.7,0.2,0.6c0,0,0.1,0,0.1,0c-0.1-0.1,0.1-0.2,0.3-0.3c-0.5,0.2,0.1-1.2,0-1.3c0.1,0.1,0-0.1,0-0.1 c0.1,0,0.6,0.1,0.6,0.1c0,0-0.1,0,0,0.1c-0.2,1-0.4,0.7,0.1,1.4c-0.6,0.6,0.3,2,0.5,3.1c0.1,0,0.2,0,0,0c0,0.1,0,0.1,0,0.2 c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0.1,0,0.1,0,0.1,0.1c0.1-0.1,0,0,0.1,0c-0.1-0.3,0-0.6,0.1-0.9c0,0-0.1-0.1,0,0c0,0,0,0,0,0 c0.2-0.3,0.4-0.7,0.2-1.1c0,0,2.1,1.3,1.8,0.6c0.2,0.6,1.3,2.3,1.2,2.4c-0.1,0.1,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0l0,0 c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0-0.2,0.1c0,0,0.2-0.1,0-0.1c0,0-0.5-0.1-0.5-0.1c-0.2-0.3,0.2,0.1,0-0.1c0,0,0.3-0.4,0.4-0.5 c-0.3,0.1-0.6,0-0.9,0c0,0,0.1,0,0.1,0.1c0.3,0.2-0.1-0.1-0.1-0.1c-0.3,0-0.6,0.1-0.8,0.2c0.6-0.4,0.6,0.1,0.7,0.4c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c-1.3-0.3-1.6,2.3-2.7,3c-0.4,0.3-0.7,0.3-0.9,0.1c0,0.1,0,0.2,0,0.3c0.4,2.1,1,0.6,1.9,1.5 c0,0-0.3,0.4-0.1,0.4C26.6,36.7,30.2,37.5,30.8,39.3C30.8,39.3,30.8,39.3,30.8,39.3C30.8,39.4,30.8,39.4,30.8,39.3z M27.2,31.1 C27.3,31.1,27.2,31.1,27.2,31.1L27.2,31.1z M24.9,31.7C24.9,31.6,24.9,31.7,24.9,31.7L24.9,31.7z M25.5,31.8 C24.9,32,26.2,31.6,25.5,31.8L25.5,31.8z M26,33C26.1,33,26,33,26,33L26,33z M26,32.9C26,32.9,26.1,32.9,26,32.9L26,32.9z  M26.2,32.4C26.3,32.4,26.3,32.3,26.2,32.4L26.2,32.4z M26.1,32.7C26.2,32.4,26.2,32.5,26.1,32.7L26.1,32.7z M25.9,31.7 C25.8,31.7,25.8,31.8,25.9,31.7L25.9,31.7z M25.4,31.2C24.7,31,26.4,31.8,25.4,31.2L25.4,31.2z M24.6,27.8 C24.5,27.8,24.7,27.8,24.6,27.8L24.6,27.8z M18.7,28.1C18.7,28.1,18.7,28.1,18.7,28.1C18.7,28.1,18.7,28.1,18.7,28.1L18.7,28.1 C18.7,28.1,18.7,28.1,18.7,28.1C18.7,28.1,18.7,28.1,18.7,28.1z M19,28.4C19,28.4,19,28.4,19,28.4C19,28.4,19,28.4,19,28.4 C19,28.4,19,28.4,19,28.4z M19,28.5C19,28.5,19,28.5,19,28.5C19,28.5,19,28.5,19,28.5C19,28.5,19,28.5,19,28.5z M19.8,29.6 C19.8,29.7,19.9,29.7,19.8,29.6L19.8,29.6z M20.2,30.1C20.4,30.3,19.7,29.8,20.2,30.1L20.2,30.1z M21.9,27.8 C21.9,27.8,20.9,28.1,21.9,27.8L21.9,27.8z M22.6,26.7C22.6,26.7,22.5,26.7,22.6,26.7L22.6,26.7z M22.7,26.5 C22.6,26.5,22.8,26.5,22.7,26.5L22.7,26.5z M23.7,29.8C23.7,29.8,23.7,29.8,23.7,29.8C23.3,29.1,23.8,30.1,23.7,29.8z M23.7,30.1 C23.7,29.8,23.6,30.3,23.7,30.1L23.7,30.1z M25.2,36.5C25.3,36.6,25.2,36.5,25.2,36.5L25.2,36.5z M24.6,44.6 C24.6,44.6,24.6,44.6,24.6,44.6C24.7,44.6,24.7,44.6,24.6,44.6z M24.7,45.2C24.7,45.1,24.6,45.1,24.7,45.2L24.7,45.2z M24.8,45.4 C24.8,45.4,24.8,45.2,24.8,45.4L24.8,45.4z M25,45.6C25,45.6,24.9,45.5,25,45.6L25,45.6z M28.7,38.4 C28.7,38.4,28.8,38.4,28.7,38.4L28.7,38.4z M28.8,38.3C28.6,38.3,29,38.3,28.8,38.3L28.8,38.3z M24.5,45C24.6,45,24.6,45,24.5,45 C24.6,45.1,24.6,45.1,24.5,45C24.6,45.1,24.6,45,24.5,45C24.6,45,24.6,45,24.5,45z M23.2,25.2C23.2,25.2,23.2,25.3,23.2,25.2 C23.3,25.3,23.3,25.3,23.2,25.2z M19.4,25.9C19.4,25.9,19.4,25.9,19.4,25.9C19.4,25.9,19.4,25.9,19.4,25.9z M19.6,25.8 C19.5,25.7,19.4,25.8,19.6,25.8L19.6,25.8z M28.8,27.7C28.8,27.7,28.8,27.7,28.8,27.7C28.8,27.7,28.8,27.7,28.8,27.7z M26.5,25.9 C26.5,25.9,26.5,25.9,26.5,25.9L26.5,25.9z M26,26.6c-0.1,0-0.2,0-0.3,0.1c-0.4-0.4-0.7-0.8,0.2-1.1c0,0,0,0,0.1,0 c-0.2,0.1-0.3,0.2-0.2,0.4c0.6,0,3,0.3,3.1,1.6c0,0,0,0.1,0,0.1c0,0-0.2,0.1-0.1,0.1c-0.2,0,0,0-0.1,0c0,0-0.3,0.1-0.1,0.1 C28.4,28,28,27.6,28,27.7c0,0,0,0.1,0,0.1c0.4,0.1,0.3,0.7,0.3,0.7c-0.1-0.1-0.1,0,0,0.1c-0.4-0.2-0.6-0.2-0.2,0.1 c-0.2-0.2-1.5-0.7-1.5-0.8c-0.1-0.2,0.2-0.4,0.3-0.6c-0.2,0-0.1,0,0,0c0.1-0.1,0.2-0.3,0-0.4c0,0,0,0,0,0c0,0,0,0,0,0 c-0.1-0.1-0.3-0.2-0.7-0.3C26.3,26.6,26,26.6,26,26.6z M27.6,26.7C27.6,26.6,27.6,26.7,27.6,26.7L27.6,26.7z M27.8,28.3 C27.8,28.4,27.8,28.2,27.8,28.3L27.8,28.3z M27.6,26.6C27.7,26.6,27.6,26.6,27.6,26.6L27.6,26.6z M27.5,26.5 C27.5,26.5,27.5,26.5,27.5,26.5C27.6,26.5,27.5,26.5,27.5,26.5z M25.8,26.5C25.6,26.5,25.9,26.5,25.8,26.5L25.8,26.5z M25.8,26.2 C25.7,26.1,26,26.2,25.8,26.2L25.8,26.2z M28.5,31.7C28.6,31.6,28.4,31.6,28.5,31.7c0.1-0.1-0.1-0.1,0-0.1c0,0,0,0,0-0.1 c0,0.1-0.1,0.1-0.1,0.1C28.3,31.6,28.4,31.6,28.5,31.7C28.3,31.6,28.4,31.7,28.5,31.7z M25.8,25.6C25.8,25.6,25.9,25.6,25.8,25.6 C25.9,25.6,25.8,25.6,25.8,25.6z M25.5,27C25.4,27.1,25.6,26.7,25.5,27c0.1-0.2,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.1-0.1 c-0.2,0.1-0.3,0.1-0.4,0.2c0,0.1,0.1,0.1,0.1,0.2C25.4,27.1,25.4,27.1,25.5,27z M26.5,25.9C27,26.3,26.5,25.9,26.5,25.9L26.5,25.9 z M28,31.5C27.9,31.5,28,31.6,28,31.5L28,31.5z M27.1,26.2C27.1,26.2,27,26.3,27.1,26.2C27.1,26.2,27.1,26.2,27.1,26.2z  M25.4,31.2C25.4,31.2,25.5,31.2,25.4,31.2L25.4,31.2z M25,27.4C25.2,27.6,25.1,27.4,25,27.4L25,27.4z M27.5,26.5 C27.5,26.5,27.5,26.5,27.5,26.5C27.5,26.5,27.5,26.5,27.5,26.5z M23.7,29.8C23.7,29.8,23.7,29.8,23.7,29.8 C23.6,29.8,23.7,29.8,23.7,29.8z M27.2,35.6C27.2,35.6,27.1,35.5,27.2,35.6L27.2,35.6z M27.2,35.6C27,35.5,26.9,35.4,27.2,35.6 L27.2,35.6z M26.7,35.4C26.7,35.4,26.8,35.4,26.7,35.4L26.7,35.4z M26.7,35.4C26.3,35.3,25.6,35.1,26.7,35.4L26.7,35.4z  M25.7,35.4C25.8,35.5,25.3,35.1,25.7,35.4L25.7,35.4z M30,26.8C30,26.8,30,26.8,30,26.8C30,26.8,30,26.8,30,26.8z M27.9,24.8 c0,0,0.1,0,0.1,0C28,24.9,27.9,24.8,27.9,24.8z M35.9,30.5C35.9,30.5,35.8,30.6,35.9,30.5L35.9,30.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1003_",
    className: "st17",
    cx: 24.4,
    cy: 34.2,
    r: 12.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1205_"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1204_",
    cx: 30.7,
    cy: 26.4,
    r: 8.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_1204_",
    style: {
      overflow: "visible"
    }
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1004_",
    className: "st38"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1203_",
    className: "st36",
    points: "35.6,23.9 35.6,23.9 35.6,23.9  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1202_",
    className: "st36",
    d: "M35.6,23.8C35.6,23.8,35.6,23.8,35.6,23.8C35.6,23.8,35.6,23.8,35.6,23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1201_",
    className: "st28",
    d: "M38.5,33.1c0.1,8.3-6.5,15.2-14.9,15.4C15.3,48.6,8.4,42,8.2,33.6 c-0.1-8.3,6.5-15.2,14.9-15.4C31.4,18.1,38.3,24.7,38.5,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1006_",
    className: "st8",
    d: "M37.7,28.7C37.9,28.7,37.7,28.7,37.7,28.7L37.7,28.7z M37.8,29C37.6,29.4,37.8,29,37.8,29 L37.8,29z M31.6,27.4c0.1,0-2.7-2.6-0.7-2.7c0,0,0-0.1,0-0.2c-0.1,0,0,0,0,0.1c0-0.2-0.4,0-0.7,0c-0.1,0,0.1-0.1,0-0.1 c0,0,0-0.1,0-0.1c0.1,0,0.1,0,0-0.1c0,0,0.4-0.3,0.5-0.1c0-0.1-0.1-0.1,0-0.1c0-0.2-1.4-1.6-2.5-2.3c0,0,0,0.1-0.1-0.1 c-0.3-0.2-0.5-0.3-0.7-0.4c0.1,0,0-0.1,0-0.1c1.6,0.4,2.5-1.5,3.8-1c0,0,0.1,0,0.1,0.1c0,0,0,0,0.1,0c0,0,0,0,0,0 c0,0,0.1,0.1,0.1,0.1c-0.1-0.2,4.2,2.8,3.8,3.5c0,0,0,0,0,0c0,0,0,0.1-0.1,0.1c0.1,0.1,0.1,0.1,0,0.1c0.3,0.1,0.2,0,0.1,0 c0.5,0.1,0.4,0.5,0.4,0.8c0-0.2-1.6,0.1-0.1,0.3C32.9,24.8,32.4,26.6,31.6,27.4z M30.7,24C30.7,24,30.7,24,30.7,24L30.7,24z  M30.7,24.2C30.7,24.2,30.9,24.2,30.7,24.2L30.7,24.2z M30.3,25.5C30.4,25.4,30.2,25.4,30.3,25.5L30.3,25.5z M30.4,25 C30.5,25,30.5,24.9,30.4,25L30.4,25z M30.7,24.9C30.4,24.9,30.8,24.9,30.7,24.9L30.7,24.9z M30.6,25.3 C30.6,25.3,30.7,25.4,30.6,25.3L30.6,25.3z M30.7,25.1C31,25.3,30.5,24.8,30.7,25.1L30.7,25.1z M34.9,24C34.9,24,35,24.1,34.9,24 L34.9,24z M34.7,24.8C34.9,24.7,34.4,24.8,34.7,24.8L34.7,24.8z M34.8,24.9C35,24.8,34.5,24.9,34.8,24.9L34.8,24.9z M34.9,24.1 C34.8,24.1,35.2,24.1,34.9,24.1L34.9,24.1z M35.6,25.1C35.6,25.1,35.6,25.1,35.6,25.1L35.6,25.1z M35.3,24.1 C35.3,24.1,35.3,24.1,35.3,24.1C35.3,24.1,35.3,24.1,35.3,24.1z M34.7,24.8C34.7,24.8,34.6,24.8,34.7,24.8L34.7,24.8z M35.3,24 C35.3,24,35.3,24,35.3,24C35.3,24,35.3,24,35.3,24C35.3,24,35.3,24,35.3,24z M30.6,24C30.7,24,30.5,24,30.6,24L30.6,24z  M14.2,25.1c0,0,0.1-0.1,0.1-0.1C14.3,24.9,14.2,25,14.2,25.1z M11.4,25.8C11.7,25.9,10.8,25.8,11.4,25.8L11.4,25.8z M14.4,24.9 C14.4,24.9,14.5,25,14.4,24.9C14.5,24.9,14.5,24.9,14.4,24.9z M22.1,21.3C22.3,21.4,22.1,21.1,22.1,21.3L22.1,21.3z M22.4,21.4 C22.5,21.4,22.4,21.4,22.4,21.4C22.4,21.4,22.4,21.4,22.4,21.4C22.4,21.4,22.4,21.4,22.4,21.4c-0.1-0.1-0.2-0.1-0.1,0 C22.1,21.5,22.2,21.5,22.4,21.4C22.3,21.4,22.4,21.4,22.4,21.4z M22.4,21.4C22.4,21.4,22.5,21.4,22.4,21.4L22.4,21.4z M22.3,20.5 C22.4,20.6,22.3,20.5,22.3,20.5L22.3,20.5z M22.3,20.5C22.3,20.6,22.5,20.5,22.3,20.5L22.3,20.5z M22.4,20.5 C22.3,20.5,22.4,20.5,22.4,20.5L22.4,20.5z M22.1,20.4C22.9,20.7,23,20.8,22.1,20.4L22.1,20.4z M22.1,20.4 C22.2,20.4,22.1,20.3,22.1,20.4L22.1,20.4z M27.5,26.7C27.5,26.7,27.6,26.7,27.5,26.7C27.6,26.6,27.5,26.7,27.5,26.7z M22.1,21 C22.1,21,21.7,21,22.1,21C22.1,21,22.1,21,22.1,21z M22.7,20.9c0.1,0-0.1-0.1-0.2-0.1C22.5,20.8,22.6,20.9,22.7,20.9z M23.1,20.2 C23.5,20.2,22.8,20.1,23.1,20.2L23.1,20.2z M26.3,21.9C26.3,21.9,26.2,22,26.3,21.9C26.3,22,26.4,22,26.3,21.9z M24.9,33.7 C24.8,33.7,24.9,33.7,24.9,33.7C24.9,33.7,24.9,33.7,24.9,33.7z M22.9,21.3C23,21.4,22.6,21.2,22.9,21.3L22.9,21.3z M22.9,21.5 C22.8,21.5,22.9,21.6,22.9,21.5L22.9,21.5z M22.7,21.3C22.7,21.3,22.8,21.3,22.7,21.3L22.7,21.3z M22.5,21.3 C22,21.5,24.1,20.9,22.5,21.3L22.5,21.3z M22.9,21.4C22.9,21.4,22.9,21.4,22.9,21.4C22.6,21.3,23,21.4,22.9,21.4z M29,20.3 c-0.2,0-0.3,0-0.4,0C29.1,20.5,28.6,20.3,29,20.3z M25.6,19.9C25.6,19.9,25.6,19.9,25.6,19.9C25.6,19.9,25.6,19.9,25.6,19.9z  M24.6,19.7c-0.1,0-0.1,0-0.1,0C24.5,19.7,24.6,19.7,24.6,19.7z M26.5,20.1C26.5,20.1,26.5,20.1,26.5,20.1 C26.5,20.2,26.5,20.1,26.5,20.1z M26.5,20.2C26.5,20.2,26.5,20.2,26.5,20.2C26.5,20.2,26.5,20.2,26.5,20.2 C26.5,20.2,26.5,20.2,26.5,20.2C26.5,20.2,26.5,20.2,26.5,20.2z M23.6,20.2c-0.3-0.6,1.8-0.1,2.5,0.4c0-0.1-0.4-0.2-0.1-0.2 c-0.1-0.1-0.1-0.1,0-0.1c-0.2,0-0.1,0,0.1-0.1c-0.9,0.2-1.1-0.4-1.4-0.4c0.2,0,0.1,0,0-0.1c0.1,0,0,0-0.1-0.1 c0.2,0.1,5.2-0.6,5.1,0.5c0,0,0,0,0,0.1c0,0.2-1.1,0.1-1.3,0.1c0.1,0,0.2,0.1,0.2,0.1c-0.8,0-1.1,0.6-1.9,0.6 c-0.1,0,0.2,0.1,0.1,0c0.6,0.3-1,1.3-2.2,0.7c0,0,0-0.2,0-0.2c0.1-0.4,0.6,0,0.8-0.2c-0.1,0-0.1,0-0.1,0c-0.1,0,0,0,0.1-0.1 c-0.1,0-0.5-0.2-0.4-0.3C24.4,21,23.9,20.7,23.6,20.2C23.6,20.2,23.6,20.2,23.6,20.2C23.6,20.1,23.6,20.2,23.6,20.2z M27.1,19.6 C27.1,19.6,27,19.6,27.1,19.6L27.1,19.6z M25.6,19.6C25.5,19.6,25.5,19.6,25.6,19.6L25.6,19.6z M25.6,19.9 C25.5,19.9,25.5,19.9,25.6,19.9C25.1,20,25.4,20.1,25.6,19.9z M26.7,20.9C26.6,20.9,26.7,20.9,26.7,20.9L26.7,20.9z M26.6,20.9 C26.7,20.9,26.6,20.9,26.6,20.9L26.6,20.9z M26.5,20.2C26.6,20.3,26.6,20.2,26.5,20.2C26.6,20.2,26.6,20.1,26.5,20.2 C26.5,20.1,26.5,20.1,26.5,20.2C26.5,20.1,26.5,20.1,26.5,20.2C26.5,20.2,26.5,20.2,26.5,20.2c0,0-0.1,0-0.2,0.1 C26,20.4,26.4,20.3,26.5,20.2z M25.9,21.4C26.1,21.4,25.9,21.4,25.9,21.4L25.9,21.4z M25.5,21.3C25.5,21.3,25.5,21.3,25.5,21.3 L25.5,21.3z M25.5,21C25.5,21.1,25.5,21,25.5,21L25.5,21z M25.4,20.8C25.3,20.8,25.5,20.7,25.4,20.8L25.4,20.8z M26.3,20.3 C26.3,20.3,26.4,20.3,26.3,20.3L26.3,20.3z M24.4,21.3C24.4,21.3,24.4,21.3,24.4,21.3C24.5,21.3,24.8,21.2,24.4,21.3z M22.5,23.7 C22.7,23.7,22.4,23.7,22.5,23.7C22.5,23.7,22.5,23.7,22.5,23.7z M25,24.8c0,0,0,0.2,0.1,0.1C25.2,25,25,24.9,25,24.8z M20.6,20.6 C20.6,20.6,20.4,20.6,20.6,20.6L20.6,20.6z M27.2,26.1c0,0-0.1-0.1-0.1-0.1C27.1,26,27.2,26.1,27.2,26.1z M20.9,20.8 C20.2,20.6,21.8,21.1,20.9,20.8L20.9,20.8z M22.2,23.8C22.2,23.8,22.2,23.7,22.2,23.8C22.2,23.7,22.2,23.8,22.2,23.8z M27.5,21.7 c0,0,0.1,0,0.1,0C27.6,21.7,27.5,21.6,27.5,21.7z M26,24.2c0,0,0.1,0,0.1-0.1c0.1,0,0.1,0,0,0c0,0,0,0,0,0 C26.1,24.1,26.1,24.1,26,24.2C26,24.1,26,24.1,26,24.2C26,24.1,26,24.1,26,24.2C26,24.1,26,24.2,26,24.2z M25.6,34.4 C25.6,34.4,25.6,34.4,25.6,34.4C25.6,34.4,25.6,34.5,25.6,34.4z M37.9,29.6C38,29.6,38,29.6,37.9,29.6 C37.9,29.6,37.9,29.6,37.9,29.6z M37.8,29C37.8,29,37.8,29.1,37.8,29L37.8,29z M24.8,29.7c0,0-0.2-0.1-0.2,0 C24.6,29.6,24.8,29.7,24.8,29.7z M23.5,47.3C23.5,47.2,23.5,47.2,23.5,47.3C23.6,47.3,23.5,47.2,23.5,47.3z M23.8,45.7 C23.9,45.8,24,45.9,23.8,45.7L23.8,45.7z M23.8,47.6c0,0-0.2-0.1-0.2-0.1C23.6,47.5,23.8,47.6,23.8,47.6z M26.6,35.1 C27.1,35.2,26.6,35.1,26.6,35.1L26.6,35.1z M26.6,35.1C26.5,35.1,26.7,35.1,26.6,35.1L26.6,35.1z M25.2,34.6 C23.3,33.6,24.2,34.1,25.2,34.6L25.2,34.6z M25.2,34.6C25.2,34.6,25.2,34.5,25.2,34.6L25.2,34.6z M24,33.9 C24.4,33.8,24.1,33.8,24,33.9L24,33.9z M36.9,30C38.8,29.7,36.9,30,36.9,30C36.9,30,36.9,30,36.9,30z M37.7,28.8 C37.8,28.9,37.7,28.9,37.7,28.8C37.7,28.8,37.7,28.8,37.7,28.8z M37.9,29.8C38,30.4,38.2,30.8,37.9,29.8L37.9,29.8z M35.5,24.1 C35.5,24.1,35.5,24.1,35.5,24.1L35.5,24.1z M38.2,33.3c-0.9,0.7,0.3-1.2,0.1-2.5c-0.1,0.1-0.2-0.1-0.3-0.1 c-0.1,0-0.3,0.1-0.2,0.1c0,1-0.9,2.6-2.5,4.3c-0.4,0.5-0.3,1.3-0.4,1.8C33.3,41.7,39.8,31.9,38.2,33.3z M14.2,25 c0,0,0.1-0.1,0.1-0.1C14.4,24.9,14.2,24.9,14.2,25z M11.9,32.7C11.9,32.7,11.9,32.7,11.9,32.7C12.2,32.8,11.9,32.6,11.9,32.7z  M13.5,25.3C13.6,25.5,13.3,25,13.5,25.3L13.5,25.3z M11.4,25.8C11.7,25.8,10.8,25.7,11.4,25.8L11.4,25.8z M11,26 C11,26.1,11,26.2,11,26L11,26z M11,26C11,26,11,25.9,11,26L11,26z M16.8,27.1C16.8,27.1,16.9,27.1,16.8,27.1L16.8,27.1z  M16.8,27.1C16.3,26.9,16.5,27,16.8,27.1L16.8,27.1z M22.2,21.6C22.1,21.7,22,21.7,22.2,21.6L22.2,21.6z M27.6,26.6 C27.6,26.6,27.5,26.6,27.6,26.6C27.5,26.6,27.6,26.6,27.6,26.6z M22.6,20.7c-0.1,0,0,0.1,0.2,0.1C22.8,20.8,22.6,20.7,22.6,20.7z  M28.2,26.4C28.2,26.1,28,26.8,28.2,26.4L28.2,26.4z M26.3,21.9C26.3,21.9,26.2,21.9,26.3,21.9C26.3,21.9,26.4,21.9,26.3,21.9z  M23.3,20.6C24.1,21.3,23.8,21,23.3,20.6L23.3,20.6z M24.5,21.5C24.5,21.5,24.6,21.4,24.5,21.5C24.5,21.3,24.5,21.4,24.5,21.5z  M22.5,23.6C22.7,23.5,22.4,23.6,22.5,23.6L22.5,23.6z M23.7,21.6C23.7,21.6,23.7,21.6,23.7,21.6C23.8,21.6,23.7,21.6,23.7,21.6z  M22.5,22.3c-0.9,0.3,1.1,0.8,0.8,0.3C23.1,22.2,22.9,22.1,22.5,22.3z M25.7,25.8C25.7,25.8,25.7,25.8,25.7,25.8 C25.5,25.8,25.9,25.9,25.7,25.8z M23.9,21.8C23.9,21.8,23.9,21.8,23.9,21.8C23.3,21.3,24,21.9,23.9,21.8z M25,24.9 C25,24.9,24.9,24.8,25,24.9C24.9,24.8,24.9,24.9,25,24.9z M25.3,25.7c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.2,0.1,0,0 c0,0.1,0,0.1,0,0c0.1-0.1,0.2-0.1,0.3-0.3c0,0-0.2,0.2-0.3,0.3C25.3,25.8,25.3,25.7,25.3,25.7z M24.4,21.6 c0.3,0.1,0.5,0.2,1.5,0.4C25.5,21.9,25,21.8,24.4,21.6C24.5,21.6,24.5,21.6,24.4,21.6c0,0-0.1,0-0.1-0.1 C24.3,21.6,24.4,21.6,24.4,21.6C24.4,21.6,24.4,21.6,24.4,21.6C24.4,21.6,24.4,21.6,24.4,21.6z M26.2,22.1 C26.2,22.1,26.1,22.1,26.2,22.1L26.2,22.1z M23.4,21.3c0.4,0.2,0.7,0.3,0.8,0.3c-0.3-0.1-0.6-0.1-0.7-0.1 C23.6,21.4,23.6,21.4,23.4,21.3C23.4,21.3,23.5,21.3,23.4,21.3z M23.9,21.5C24.1,21.5,23.9,21.5,23.9,21.5L23.9,21.5z M25.9,22 c0.1,0,0.2,0,0.3,0.1C26.1,22,26,22,25.9,22z M20.4,21C20.3,21,20.3,21,20.4,21L20.4,21z M21.9,21.3c-0.6-0.4-0.9-0.1-1.5-0.3 c-0.1,0-0.1,0-0.1,0c0,0-1.1-0.2-1.1-0.1c0.8,0.1,1.1,0.1,1.1,0.1C18.7,21.3,22.1,21.4,21.9,21.3z M26.1,25.6 C26,25.7,25.9,25.9,26.1,25.6L26.1,25.6z M20.5,20.8c-0.1,0,0,0,0.1,0.1C20.7,20.9,20.6,20.8,20.5,20.8z M27.6,21.6 c0,0-0.2,0-0.1,0C27.5,21.6,27.7,21.6,27.6,21.6z M26,24.1C26,24.1,26,24.1,26,24.1L26,24.1z M25.6,34.3 C25.6,34.3,25.6,34.3,25.6,34.3C25.6,34.3,25.6,34.4,25.6,34.3z M29.7,29.7C29.7,29.8,29.7,29.7,29.7,29.7L29.7,29.7z M29.7,29.7 C29.7,29.7,29.7,29.7,29.7,29.7C29.7,29.7,29.7,29.7,29.7,29.7z M35.3,26.8c0,0.1,1.2,0.3,1.3,0c0.6-0.8-0.9-0.5-0.9-0.5 C34.9,25.7,35.3,26.7,35.3,26.8z M38,29.5C38,29.5,38,29.5,38,29.5C38,29.5,38,29.5,38,29.5z M37.9,28.8 C37.8,28.8,37.8,28.8,37.9,28.8C37.8,28.8,37.9,28.8,37.9,28.8z M37.8,28.9C37.9,28.9,37.9,28.9,37.8,28.9L37.8,28.9z M23.9,45.7 C23.7,45.6,24.1,45.7,23.9,45.7L23.9,45.7z M11.8,25.7C11.9,25.7,11.8,25.7,11.8,25.7L11.8,25.7z M27.9,29.9 C27.9,29.9,27.9,29.9,27.9,29.9L27.9,29.9z M17.4,22.8C17.7,22.7,17.3,22.9,17.4,22.8L17.4,22.8z M28.3,30 c-0.1-0.1-0.3-0.1-0.4-0.1C27.9,30.1,28,30.2,28.3,30z M25.8,23.9C26,23.9,25.5,23.9,25.8,23.9C25.8,23.9,25.8,23.9,25.8,23.9z  M31.4,39.7c1,2.9-7.3,5.6-6.8,7.9c-0.6,0-0.6,0.1-1-0.3c0.1,0.1,0-0.2,0-0.5c0,0,0,0,0,0c0,0,0-0.1,0,0c0,0,0.1-0.1,0.1-0.1 c0,0-0.1-0.1,0-0.1c0-0.1-0.1,0-0.1,0c0,0,0,0,0,0c0,0.1,0,0.1-0.1,0.1c0-0.1,0-0.1-0.1-0.1c0,0,0,0,0,0.1c0-0.1,0-0.1,0-0.2 c0,0,0,0,0,0c-0.3-0.3,0.9-0.9,0.6-1.5c1.1,0.1-0.5-9,0.1-8.9c-0.9-0.2-4.8-2.2-5-4.2c0-0.1-0.2-0.6-0.3-0.5 c0,0.3,0.9,1.5,0.6,1.7c0.1-0.1-2.3-5.4-2.9-6.9c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0-0.1-0.2-0.1,0c0,0,0-0.1-0.1-0.1 c0.1,0-0.1-0.6,0-0.7c-0.1,0.2,0,0.4-0.1,0.5c0.1-0.1,0-0.5-0.1-0.7c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0.1,0,0,0,0,0h0c0,0,0,0-0.1,0 c0,0.1,0,0.4,0,0.5c-0.4-0.6-2.4-1.6-2.5-1.5c-0.4,0.2-1.2,1.4-1.8,1.2c0-0.1,0-0.1-0.1,0c-0.1,0,0,0,0,0c0,0-0.1,0-0.2,0.1 c0.1,0,0.7-0.5,0.9-0.7c0,0,0,0,0-0.1c-0.1,0-0.2-0.1-0.1-0.1c-0.8-0.2-1.8-0.7-0.3-1.5c0.3,0.3,2.6-0.4,4.9-0.6c0,0,0,0.2,0,0 c0,0,0,0,0,0c1.7-0.1,3.3,0,4.1,1.1c0,0,0,0.1,0,0.1c0-0.1,0-0.1,0-0.1c-0.1-0.3-0.2-0.6,0.3-0.5c-0.2-0.1-3.2-0.7-1.1-0.6 c-0.4-0.2-1.5-0.5-0.7-0.9c-0.9,0.2-0.6,0.2-1.4,0.1c0.1-0.1,0.1-0.1,0-0.1c0.1,0,0.4-0.6,0.3-0.6c0.1,0,0.1,0,0-0.1 c0.7-0.1,2.9,0.7,3.2,0.7c0,0.3-0.1,1.2,0.5,1.3c-0.6-0.1,0.3,0.3-0.8,0.1c1,0.7,1.1,0.1,1.1,0.1c0.1,0,0.1,0,0-0.1 c0.1,0,0.2-0.1,0.2-0.2c0.4-0.2,0.3,0.8,0.2,0.8c0,0,0.1,0,0.1,0c-0.1-0.2,0.1-0.3,0.3-0.3c-0.7,0.3,0.1-1.5,0-1.6 c0.1,0.1,0.1-0.1,0-0.1c0.1,0,0.8,0.1,0.8,0.2c-0.1,0-0.1,0.1,0,0.1c-0.2,1.2-0.5,0.9,0.1,1.7c-0.8,0.8,0.3,2.5,0.7,3.8 c0.1,0,0.3,0,0,0c0,0.1,0,0.1,0,0.2c0.1,0,0,0,0,0c0,0.1,0,0.2,0,0.2c0.1,0,0.1,0,0.2,0.1c0.1-0.2,0.1,0,0.1-0.1 c-0.1-0.4,0-0.7,0.2-1.1c0,0-0.2-0.2,0-0.1c0,0,0,0,0,0.1c0.2-0.4,0.4-0.9,0.3-1.4c0,0.1,2.6,1.6,2.2,0.7c0.3,0.8,1.6,2.9,1.5,3 c-0.2,0.1,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0l0,0c-0.1,0-0.1,0.1-0.2,0.2c-0.1,0-0.2,0.1-0.3,0.1c0,0,0.2-0.1,0-0.1 c0,0-0.6-0.1-0.6-0.2c-0.3-0.4,0.2,0.2,0-0.1c0,0,0.4-0.6,0.5-0.7c-0.4,0.1-0.8,0-1.2,0.1c0,0,0.1,0.1,0.2,0.1 c0.4,0.3-0.1-0.1-0.2-0.1c-0.4,0-0.7,0.1-1,0.3c0.7-0.5,0.8,0.1,0.9,0.5c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c-1.7-0.4-2,2.8-3.4,3.7c-0.6,0.4-0.9,0.3-1.2,0.1c0,0.1,0,0.2,0,0.3c0.5,2.6,1.2,0.7,2.4,1.8c0,0-0.3,0.5-0.1,0.5 C26.1,36.4,30.6,37.5,31.4,39.7C31.4,39.7,31.4,39.6,31.4,39.7C31.4,39.8,31.4,39.7,31.4,39.7z M26.9,29.5 C27,29.4,26.9,29.4,26.9,29.5L26.9,29.5z M24,30.1C24,30.1,24,30.1,24,30.1L24,30.1z M24.8,30.3C24,30.5,25.6,30,24.8,30.3 L24.8,30.3z M25.4,31.8C25.5,31.8,25.3,31.7,25.4,31.8L25.4,31.8z M25.4,31.7C25.4,31.7,25.4,31.6,25.4,31.7L25.4,31.7z M25.7,31 C25.7,31.1,25.8,30.9,25.7,31L25.7,31z M25.5,31.4C25.7,31,25.6,31.1,25.5,31.4L25.5,31.4z M25.2,30.2 C25.1,30.2,25.1,30.2,25.2,30.2L25.2,30.2z M24.7,29.6C23.7,29.3,25.9,30.3,24.7,29.6L24.7,29.6z M23.6,25.2 C23.6,25.3,23.7,25.3,23.6,25.2L23.6,25.2z M16.2,25.7C16.2,25.6,16.2,25.7,16.2,25.7C16.3,25.7,16.3,25.7,16.2,25.7L16.2,25.7 C16.3,25.7,16.3,25.7,16.2,25.7C16.3,25.7,16.3,25.7,16.2,25.7z M16.6,26.1C16.6,26.1,16.6,26.1,16.6,26.1 C16.6,26.1,16.6,26.1,16.6,26.1C16.6,26.1,16.6,26.1,16.6,26.1z M16.6,26.1C16.6,26.1,16.6,26.1,16.6,26.1 C16.6,26.1,16.6,26.1,16.6,26.1C16.6,26.1,16.6,26.1,16.6,26.1z M17.7,27.6C17.6,27.7,17.7,27.6,17.7,27.6L17.7,27.6z M18.1,28.2 C18.4,28.4,17.5,27.8,18.1,28.2L18.1,28.2z M20.2,25.3C20.3,25.3,19,25.7,20.2,25.3L20.2,25.3z M21.1,24C21.1,24,21,23.9,21.1,24 L21.1,24z M21.3,23.7C21.2,23.7,21.3,23.7,21.3,23.7L21.3,23.7z M22.4,27.8C22.4,27.8,22.4,27.8,22.4,27.8 C22,27,22.6,28.2,22.4,27.8z M22.6,28.2C22.5,27.7,22.4,28.4,22.6,28.2L22.6,28.2z M24.3,36.2C24.5,36.3,24.3,36.2,24.3,36.2 L24.3,36.2z M23.7,46.3C23.7,46.3,23.7,46.3,23.7,46.3C23.7,46.3,23.7,46.3,23.7,46.3z M23.7,47C23.8,47,23.7,47,23.7,47L23.7,47 z M23.8,47.3C23.8,47.4,23.9,47.1,23.8,47.3L23.8,47.3z M24.1,47.5C24.1,47.5,24,47.4,24.1,47.5L24.1,47.5z M28.7,38.6 C28.7,38.6,28.8,38.5,28.7,38.6L28.7,38.6z M28.8,38.4C28.6,38.4,29.1,38.4,28.8,38.4L28.8,38.4z M23.6,46.9 C23.6,46.9,23.6,46.9,23.6,46.9C23.6,46.9,23.6,46.9,23.6,46.9C23.6,46.9,23.6,46.8,23.6,46.9C23.6,46.8,23.6,46.8,23.6,46.9z  M21.9,22.1C21.9,22.1,21.9,22.1,21.9,22.1C22,22.1,22,22.1,21.9,22.1z M17.1,22.9C17.1,22.9,17.1,22.9,17.1,22.9 C17.1,22.9,17.1,22.9,17.1,22.9z M17.3,22.7C17.2,22.7,17.1,22.7,17.3,22.7L17.3,22.7z M28.9,25.1C28.9,25.1,28.9,25.1,28.9,25.1 C28.9,25.1,28.9,25.1,28.9,25.1z M26,22.9C26,22.9,26,22.9,26,22.9L26,22.9z M25.4,23.8c-0.2,0-0.3,0-0.4,0.1 c-0.6-0.6-0.9-0.9,0.2-1.3c0,0,0,0,0.1,0.1c-0.2,0.1-0.4,0.3-0.2,0.5c0.8,0,3.7,0.4,3.9,2c0,0,0,0.2,0,0.1c0,0-0.2,0.2-0.2,0.2 c-0.2,0,0,0-0.1,0.1c0,0-0.3,0.1-0.2,0.2c-0.1-0.1-0.6-0.6-0.6-0.5c0,0,0,0.2-0.1,0.2c0.5,0.1,0.3,0.9,0.4,0.9 c-0.1-0.1-0.1,0,0,0.1c-0.5-0.3-0.7-0.3-0.3,0.1c-0.3-0.2-1.9-0.9-1.9-0.9c-0.2-0.3,0.2-0.5,0.4-0.7c-0.2,0-0.1,0,0,0 c0.2-0.2,0.2-0.3,0-0.6c0,0,0,0,0,0c0,0,0,0,0,0c-0.2-0.1-0.4-0.2-0.8-0.4C25.7,23.8,25.4,23.8,25.4,23.8z M27.4,23.9 C27.4,23.8,27.4,23.9,27.4,23.9L27.4,23.9z M27.6,25.9C27.7,26,27.6,25.7,27.6,25.9L27.6,25.9z M27.4,23.8 C27.5,23.8,27.4,23.8,27.4,23.8L27.4,23.8z M27.2,23.7C27.2,23.7,27.2,23.7,27.2,23.7C27.4,23.7,27.3,23.7,27.2,23.7z M25.1,23.7 C24.9,23.7,25.2,23.7,25.1,23.7L25.1,23.7z M25.2,23.3C25,23.2,25.3,23.3,25.2,23.3L25.2,23.3z M28.5,30.1 C28.6,30.1,28.3,30.1,28.5,30.1c0.1-0.1-0.1-0.1,0-0.2c0,0,0-0.1,0-0.1c-0.1,0.1-0.1,0.1-0.2,0.1C28.3,30,28.4,30,28.5,30.1 C28.3,30.1,28.4,30.2,28.5,30.1z M25.2,22.5C25.2,22.5,25.2,22.5,25.2,22.5C25.2,22.5,25.2,22.5,25.2,22.5z M24.7,24.3 C24.6,24.4,24.8,23.9,24.7,24.3c0.1-0.2,0.2-0.3,0.3-0.3c0,0-0.1-0.1-0.1-0.1c-0.2,0.1-0.4,0.2-0.5,0.3c0.1,0.1,0.1,0.2,0.2,0.3 C24.6,24.4,24.7,24.4,24.7,24.3z M26,22.9C26.6,23.5,26,22.9,26,22.9L26,22.9z M27.8,29.9C27.8,29.9,27.8,30,27.8,29.9L27.8,29.9 z M26.7,23.3C26.8,23.3,26.6,23.4,26.7,23.3C26.7,23.3,26.7,23.3,26.7,23.3z M24.7,29.6C24.6,29.5,24.7,29.6,24.7,29.6L24.7,29.6 z M24.1,24.8C24.4,25.1,24.3,24.8,24.1,24.8L24.1,24.8z M27.2,23.7C27.2,23.7,27.2,23.7,27.2,23.7C27.3,23.7,27.3,23.7,27.2,23.7 z M22.4,27.8C22.4,27.8,22.4,27.8,22.4,27.8C22.4,27.8,22.4,27.8,22.4,27.8z M26.8,35C26.9,35,26.8,35,26.8,35L26.8,35z M26.8,35 C26.7,34.9,26.5,34.8,26.8,35L26.8,35z M26.3,34.8C26.2,34.8,26.3,34.8,26.3,34.8L26.3,34.8z M26.3,34.8 C25.8,34.6,24.9,34.4,26.3,34.8L26.3,34.8z M25,34.8C25.1,34.9,24.6,34.4,25,34.8L25,34.8z M30.4,24C30.3,24,30.3,24,30.4,24 C30.4,24.1,30.4,24,30.4,24z M27.7,21.6c0,0,0.1,0,0.1,0C27.8,21.6,27.7,21.6,27.7,21.6z M37.8,28.7 C37.8,28.7,37.6,28.7,37.8,28.7L37.8,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1005_",
    className: "st17",
    d: "M38.5,33.1c0.1,8.3-6.5,15.2-14.9,15.4C15.3,48.6,8.4,42,8.2,33.6 c-0.1-8.3,6.5-15.2,14.9-15.4C31.4,18.1,38.3,24.7,38.5,33.1z"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_756_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_765_",
    className: "st17",
    x1: 37.1,
    y1: 33,
    x2: 39.9,
    y2: 35.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_762_",
    className: "st29",
    d: "M23.8,19.7c-3.8,3.8-3.8,9.9,0,13.6c3.8,3.8,9.9,3.8,13.6,0c3.8-3.8,3.8-9.9,0-13.6 C33.7,15.9,27.6,15.9,23.8,19.7z M36.7,32.6c-3.3,3.3-8.8,3.3-12.1,0c-3.3-3.3-3.3-8.8,0-12.1c3.3-3.3,8.8-3.3,12.1,0 C40.1,23.8,40.1,29.2,36.7,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_760_",
    className: "st22",
    d: "M37.8,36.3L48.4,47c0.7,0.7,2,0.7,2.7,0l-12-12L37.8,36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_759_",
    className: "st39",
    d: "M39.1,35l12,12c0.7-0.7,0.7-2,0-2.7L40.5,33.6L39.1,35z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_758_",
    className: "st17",
    x1: 39.6,
    y1: 38.3,
    x2: 42.5,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_757_",
    className: "st17",
    x1: 40.8,
    y1: 39.5,
    x2: 43.6,
    y2: 36.7
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1206_",
    className: "st17",
    x1: 19.8,
    y1: 13.2,
    x2: 24.8,
    y2: 13.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_761_",
    className: "st17",
    x1: 42.5,
    y1: 13.2,
    x2: 27,
    y2: 13.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1207_",
    className: "st17",
    x1: 38.7,
    y1: 16,
    x2: 23.2,
    y2: 16
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1208_",
    className: "st17",
    x1: 29.3,
    y1: 50.8,
    x2: 13.9,
    y2: 50.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1210_",
    className: "st17",
    x1: 41.2,
    y1: 48,
    x2: 25.7,
    y2: 48
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1209_",
    className: "st17",
    x1: 30.2,
    y1: 50.8,
    x2: 33.8,
    y2: 50.8
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1215_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1261_",
    className: "st4",
    d: "M44.4,13.4c0,0.8-1.7,0.8-1.7,1.7c0,0.8,1.7,0.8,1.7,1.7c0,0.8-1.7,0.8-1.7,1.7 c0,0.8,1.7,0.8,1.7,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1260_",
    className: "st4",
    d: "M17.5,21.9c0,0.7-1.4,0.7-1.4,1.4c0,0.7,1.4,0.7,1.4,1.4c0,0.7-1.4,0.7-1.4,1.4 c0,0.7,1.4,0.7,1.4,1.4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1213_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1279_",
    className: "st35",
    d: "M35.7,17c0,0,3.1,0.6,3.2,3.1l0,0c0,0,2.8,0.5,2,3.9c0,0,2.1,1.6,1.5,5.3l0,0 c0,0,2.9,2-0.3,4.9l0,0.3c0,0,0.4,2.4-2.4,4.5c0,0-1.2,1-3.1,3.3c-0.9,1.1-3.9,2.4-5.4-2V17.8C31.2,17.8,33.1,14.1,35.7,17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1278_",
    className: "st8",
    d: "M26.2,17c0,0-3.1,0.6-3.2,3.1l0,0c0,0-2.8,0.5-2,3.9c0,0-2.1,1.6-1.5,5.3l0,0 c0,0-2.9,2,0.3,4.9l0,0.3c0,0-0.4,2.4,2.4,4.5c0,0,1.2,1,3.1,3.3c0.9,1.1,3.9,2.4,5.4-2V17.8C30.6,17.8,28.7,14.1,26.2,17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1277_",
    className: "st17",
    d: "M39.3,25.8c-0.7,0.5-1.5,0.6-2.3,0.5c-0.8-0.1-1.5-0.6-1.9-1.3c-0.5-0.7-0.6-1.5-0.5-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1276_",
    className: "st17",
    d: "M36.9,33.6c-0.7,0.5-1.5,0.6-2.3,0.5c-0.8-0.1-1.5-0.6-1.9-1.3c-0.5-0.7-0.6-1.5-0.5-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1274_",
    className: "st17",
    d: "M34.7,29.4c-0.5-0.6-0.8-1.4-0.7-2.2c0.1-0.8,0.5-1.6,1.1-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1273_",
    className: "st17",
    d: "M40.1,33.1c-0.3-0.7-0.8-1.4-1.5-1.7C37.8,31,37,31,36.2,31.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1272_",
    className: "st17",
    d: "M36.7,21.7c-0.6-0.5-1-1.3-1-2.1c0-0.8,0.3-1.6,0.8-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1271_",
    className: "st17",
    d: "M32.8,21.8c0.8,0,1.5-0.3,2.1-0.9c0.6-0.6,0.9-1.4,0.9-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1268_",
    className: "st17",
    d: "M22.6,25.8c0.7,0.5,1.5,0.6,2.3,0.5c0.8-0.1,1.5-0.6,1.9-1.3c0.5-0.7,0.6-1.5,0.5-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1267_",
    className: "st17",
    d: "M25,33.6c0.7,0.5,1.5,0.6,2.3,0.5c0.8-0.1,1.5-0.6,1.9-1.3c0.5-0.7,0.6-1.5,0.5-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1265_",
    className: "st17",
    d: "M27.2,29.4c0.5-0.6,0.8-1.4,0.7-2.2c-0.1-0.8-0.5-1.6-1.1-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1264_",
    className: "st17",
    d: "M21.8,33.1c0.3-0.7,0.8-1.4,1.5-1.7c0.8-0.4,1.6-0.4,2.3-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1263_",
    className: "st17",
    d: "M25.1,21.7c0.6-0.5,1-1.3,1-2.1c0-0.8-0.3-1.6-0.8-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1262_",
    className: "st17",
    d: "M29.1,21.8c-0.8,0-1.5-0.3-2.1-0.9c-0.6-0.6-0.9-1.4-0.9-2.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1250_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1254_",
    className: "st17",
    x1: 17.5,
    y1: 14.8,
    x2: 19,
    y2: 14.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1253_",
    className: "st17",
    x1: 21.4,
    y1: 14.8,
    x2: 22.9,
    y2: 14.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1252_",
    className: "st17",
    x1: 20.2,
    y1: 17.4,
    x2: 20.2,
    y2: 15.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1251_",
    className: "st17",
    x1: 20.2,
    y1: 13.6,
    x2: 20.2,
    y2: 12.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1233_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1238_",
    className: "st17",
    x1: 31.4,
    y1: 12.8,
    x2: 32.2,
    y2: 12.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1237_",
    className: "st17",
    x1: 33.5,
    y1: 12.8,
    x2: 34.4,
    y2: 12.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1236_",
    className: "st17",
    x1: 32.9,
    y1: 14.3,
    x2: 32.9,
    y2: 13.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1234_",
    className: "st17",
    x1: 32.9,
    y1: 12.1,
    x2: 32.9,
    y2: 11.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1223_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1227_",
    className: "st17",
    x1: 44,
    y1: 24.6,
    x2: 44.9,
    y2: 24.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1226_",
    className: "st17",
    x1: 46.2,
    y1: 24.6,
    x2: 47.1,
    y2: 24.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1225_",
    className: "st17",
    x1: 45.5,
    y1: 26.1,
    x2: 45.5,
    y2: 25.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1224_",
    className: "st17",
    x1: 45.5,
    y1: 23.9,
    x2: 45.5,
    y2: 23.1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1212_",
    x: 15,
    y: 31.3,
    className: "st26",
    width: 32.1,
    height: 21.4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1219_",
    className: "st13",
    points: "46,31.3 46,51.8 15,51.8 15,52.8 47,52.8 47,31.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1220_",
    x: 15,
    y: 31.3,
    className: "st25",
    width: 1,
    height: 21.4
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1231_",
    className: "st40",
    points: "15,31.3 15,31.9 16.5,36 47,36 47,31.9 46.8,31.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1214_",
    className: "st26",
    points: "49,34.5 17,34.5 15,31.3 47,31.3  "
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_781_",
    x: 16,
    y: 12.4,
    className: "st3",
    width: 32,
    height: 35.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_780_",
    x: 16.5,
    y: 12.5,
    className: "st13",
    width: 31.1,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_779_",
    x: 16.5,
    y: 12.5,
    className: "st4",
    width: 31.1,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_778_",
    x: 20.6,
    y: 18.1,
    className: "st1",
    width: 23,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_777_",
    x: 20.6,
    y: 28.7,
    className: "st14",
    width: 11,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_776_",
    x: 32.5,
    y: 28.7,
    className: "st19",
    width: 11.1,
    height: 5.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_774_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_775_",
    x: 22.8,
    y: 35,
    className: "st27",
    width: 19.2,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_772_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_773_",
    x: 22.8,
    y: 40.5,
    className: "st28",
    width: 19.2,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_770_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_771_",
    x: 22.8,
    y: 42,
    className: "st28",
    width: 19.2,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_768_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_769_",
    x: 22.8,
    y: 43.5,
    className: "st28",
    width: 19.2,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_766_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_767_",
    x: 28.2,
    y: 36.8,
    className: "st27",
    width: 8.5,
    height: 0.9
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_755_",
    className: "st2",
    cx: 18.9,
    cy: 14.1,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_754_",
    className: "st2",
    cx: 20.5,
    cy: 14.1,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_753_",
    className: "st2",
    cx: 22.2,
    cy: 14.1,
    r: 0.6
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_752_",
    className: "st4",
    points: "48,20.7 48,48 41.1,48  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_1216_",
    className: "st4",
    points: "16.1,20.7 16.1,48 23.9,48  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1289_",
    className: "st4",
    d: "M26.6,42.5v-8.7c0-3,2.5-5.5,5.5-5.5l0,0c3,0,5.5,2.5,5.5,5.5v8.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1288_",
    className: "st13",
    d: "M38.6,51.6h-13c-0.5,0-1-0.5-1-1v-13c0-0.5,0.5-1,1-1h13c0.5,0,1,0.5,1,1v13 C39.6,51.1,39.1,51.6,38.6,51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1295_",
    className: "st40",
    d: "M38.8,36.6V50c0,0.4-0.4,0.8-0.8,0.8H24.6c0,0.4,0.4,0.8,0.8,0.8h13.5 c0.4,0,0.8-0.4,0.8-0.8V37.4C39.6,36.9,39.2,36.6,38.8,36.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1290_",
    className: "st5",
    cx: 32.1,
    cy: 42.2,
    r: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1291_",
    className: "st5",
    d: "M32.1,47.5L32.1,47.5c-0.4,0-0.8-0.4-0.8-0.8v-3.6c0-0.4,0.4-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.4,0.8,0.8v3.6C32.9,47.2,32.5,47.5,32.1,47.5z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_177_",
    x: 30.8,
    y: 13.7,
    className: "st4",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_176_",
    x: 45.1,
    y: 13.7,
    className: "st4",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_136_",
    x: 16.4,
    y: 13.7,
    className: "st4",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_175_",
    x: 45.1,
    y: 28,
    className: "st4",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_174_",
    x: 16.4,
    y: 28,
    className: "st4",
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_172_",
    className: "st4",
    d: "M33.3,15c6.9,0.6,12.4,6.1,13,13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_171_",
    className: "st4",
    d: "M17.7,28c0.6-6.9,6-12.3,12.9-13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_168_",
    className: "st19",
    d: "M31.9,39.6L31.9,39.6l2.1,0l3.1-9.5l-4.3-7.6h-0.7l-0.1,7.2c0.2,0.1,0.7,0.3,0.8,0.4 c0.5,0.5,0.5,1.4,0,2c-0.5,0.5-1.4,0.5-2,0c-0.5-0.5-0.5-1.4,0-2c0.1-0.1,0.5-0.4,0.7-0.4l0.2-7.2h-0.7l-4.4,7.5l3.1,9.5L31.9,39.6 z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_169_",
    className: "st4",
    x1: 19,
    y1: 14.9,
    x2: 30.6,
    y2: 14.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_159_",
    className: "st4",
    x1: 33.3,
    y1: 14.9,
    x2: 45,
    y2: 14.9
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_173_",
    className: "st12",
    points: "34,39.7 34.6,38.1 29.4,38.1 29.9,39.6 31.9,39.6 32,39.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_164_",
    x: 27.4,
    y: 39,
    className: "st26",
    width: 9.2,
    height: 11.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_165_",
    x: 33.8,
    y: 39,
    className: "st13",
    width: 2.7,
    height: 11.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_167_",
    className: "st4",
    x1: 32,
    y1: 22.6,
    x2: 32,
    y2: 29.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_166_",
    className: "st4",
    cx: 32,
    cy: 31.3,
    r: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_290_",
    className: "st4",
    x1: 24.8,
    y1: 50.3,
    x2: 39.1,
    y2: 50.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconSearchInspirationTw68Ajdgfk);
export default __webpack_public_path__ + "static/media/reshot-icon-search-inspiration-TW68AJDGFK.5ff17fdbb690f0f894e79a28a159fd5b.svg";
export { ForwardRef as ReactComponent };